'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.workshops =
    exports.register =
    exports.symbol =
    exports.vision =
    exports.activity =
    exports.educational =
    exports.contact =
    exports.footer =
    exports.signup =
    exports.about =
    exports.PERSONAL =
    exports.PERMISSIONS =
    exports.branches =
    exports.donate =
    exports.event =
    exports.thanks =
    exports.reports =
    exports.press =
    exports.PARENTS =
    exports.mainpage =
    exports.navbar =
    exports.LANGUAGE =
        void 0;
const branch_parser_1 = require('./tools/branch_parser');
const cities_1 = require('./tools/cities');
const moment = require('moment');
let YEARS_ARR = [];
let num = 0;
let year = moment('1997-01-01').format('YYYY');
for (var i = 100; i >= 0; i--) {
    let elem = moment(year).add(num, 'years').format('YYYY');
    if (elem < moment().format('YYYY') + 1) {
        YEARS_ARR.push(elem);
        num++;
    }
}
let DAYS_ARR = [];
for (var i = 1; i <= 31; i++) {
    DAYS_ARR.push(i);
}
exports.LANGUAGE = 'english';
//////////Navbar/////////
exports.navbar = {
    NAVHOME: 'Home Page',
    NAV1: 'About Us',
    NAV2: 'Branches',
    NAV3: 'Reports',
    NAV4: 'Press',
    NAV5: 'Knowledge Center',
    NAV6: 'HaLev – Members’ Portal',
    NAV7: 'Contact Us ',
    NAV8: 'Classes and lectures',
    NAV_SIGN: 'Register',
    NAV_DONATE: 'Donate',
    educational_title: 'Our Educational Outlook',
    educational_text: 'Creating a meaningful place for everyone, together. ',
    activity_title: 'Membership',
    activity_text:
        '’Krembo Wings’ activities are unique because they are adapted to children and youth with disabilities.',
    vision_title: ' ’Krembo Wings’ Vision and Values',
    vision_text:
        'Connects and brings together children and youth with and without disabilities. ',
    view_btn: 'View',
    symbol_tite: 'Ceremonies and Symbols',
    symbol_text: 'Our Vision Badge.',
    go_back: 'Back to the home page',
    navbar_h2: 'Krembo Wings',
    navbar_h4:
        'A Youth movement for children and youth with and without disabilities',
    aboutSub1: 'Our Values',
    aboutSub2: 'How It All Started',
    aboutSub3: 'Movement structure',
    aboutSub4: 'Landmarks',
    aboutSub5: 'Management',
    aboutSub6: 'Board of Directors',
    aboutSub7: 'Krembo Wings Vision',
    aboutSub8: 'Letter from the CEO',
    pressSub1: 'Projects and Collaborations',
    pressSub2: 'Press',
    pressSub3: 'Krembo Magazine',
    homeSub1: 'Our projects',
    homeSub2: 'Our values',
    homeSub22: '’Krembo Wings’ Vision Statement',
    homeSub3: 'Our Partners and Supporters',
    homeSub4: 'Awards and Honors',
};
//////////Main Page Text//////////
exports.mainpage = {
    ART_H3: 'Art exibition',
    ART_H2: "Bank Hapoalim's art exibition",
    ART_H2_2: 'for Krembo Wings Foundation',
    ART_H2_2_DOT: '.',
    ART_H1: '21.12.19',
    CATALOG_BTN: 'Click here to download the catalog',
    //BANNER//
    BANNER_H1: 'יובל שר יוסי ',
    BANNER_H2: 'למען ילדי ‘כנפיים של קרמבו’',
    BANNER_P: '*מופע טרום הבכורה',
    BANNER_BTN: '"Double Dream" Activity Terms',
    BANNER_ULAM: 'אולם סיטי הול',
    BANNER_MIKUM: 'סינמה סיטי גלילות',
    BANNER_STARTSHOW: 'תחילת המופע',
    BANNER_STARTSHOW_TIME: '21:00',
    BANNER_STARTSHOW_DATE: '26.5.2019',
    MAIN_S1_H2: 'Summer Camp',
    MAIN_S1_H3:
        'A summer camp specifically adapted for children and youth with and without disabilities',
    MAIN_S2_H2: 'Establishing New Branches',
    MAIN_S2_H3:
        'Each new branch brings joy and a sense of fulfillment to dozens of members',
    MAIN_S3_H2: 'Training and Guidance',
    MAIN_S3_H3:
        'Our training and guidance program, designed for all team members ',
    MAIN_S4_H2: 'Members',
    MAIN_S4_H3: 'Funding members with disabilities',
    MAIN_S5_H2: 'Poland Delegation',
    MAIN_S5_H3:
        'A mission of Krembo Wings’ youth delegation to memorial sites in Poland',
    MAIN_S6_H2: 'Pre-army social service year program',
    MAIN_S6_H3:
        'Pre-army instructors’ communal apartments and their estimated costs',
    MAIN_S1_READ: 'More info',
    MAIN_DONATE_CHANGE: 'Krembo Wings Commitments',
    MAIN_DONATE_CHANGE_TEXT1: 'Commitment to Full Accessibility',
    MAIN_DONATE_CHANGE_TEXT2:
        'Commitment To Create a Meaningful Place for Everyone',
    MAIN_DONATE_CHANGE_TEXT3:
        'Commitment To Conduct Socio-Educational Activities',
    MAIN_DONATE_CHANGE_TEXT4: 'Commitment To Lead a Social Change',
    STORIES_H1: 'Krembo-flavored Stories',
    STORY1_TITLE: 'Ostracized',
    STORY1_NAME: 'The Story of Liz Bishla ',
    STORY1_TEXT:
        'Liz Bishla recounts her experiences as the “class scapegoat,” how she coped with being ostracized, and what she learned from these experiences. Liz tells how Krembo Wings has given her a sense of belonging.',
    STORY2_TITLE: 'Makeover',
    STORY2_NAME: 'The Story of Michal Cohen',
    STORY2_TEXT:
        'Michal Cohen tells of her challenging teenage years, the many difficulties with which she had to cope, and how joining Krembo Wings has changed her worldview.',
    STORY3_TITLE: '“Love at first sight”',
    STORY3_NAME: 'The story of Gadi Dekel',
    STORY3_TEXT:
        'The compelling story of Gadi Dekel on his first encounters with Krembo Wings. Gadi tells how he fell in love with the Krembo Wings spirit, and with the positivity it elicits in all who are involved with the youth movement.',
    STORY4_TITLE: 'Saints',
    STORY4_NAME: 'The story of Inbal Ilser',
    STORY4_TEXT:
        'Inbal Ilser tells about her life in Krembo Wings’ first joint communal apartment in Israel, which brings together youth with and without disabilities, and why she felt strange when the supermarket cashier told her she was a “saint” for being part of Krembo Wings. ',
    STORY5_TITLE: 'Outsider',
    STORY5_NAME: 'The story of Emil Oiffman',
    STORY5_TEXT:
        'Emil Oiffman tells about the loneliness he experienced as a child, his lack of belonging, the walls he built around himself, and the brave choice he made to overcome all these challenges.',
    STORY6_TITLE: 'Baggage',
    STORY6_NAME: ' The story of Shalev Goldenberg',
    STORY6_TEXT:
        'The story of Shalev Goldenberg, how he dealt with years of emotional obstacles, and the people who helped him to overcome them.',
    STORY7_TITLE: 'Sisters',
    STORY7_NAME: ' The story of Lia and Roni Kimchi',
    STORY7_TEXT:
        'Lia and Roni are sisters that tell of their special connection, and of their joint experiences in Krembo Wings. Lia eventually became the lead coordinator of the Tsur Igal branch, and sister Roni an outgoing Krembo Wings member.',
    STORY8_TITLE: 'On Being Different',
    STORY8_NAME: 'The story of Kessem Bar',
    STORY8_TEXT:
        'The story of Kessem Bar and her transformation of feeling different to feeling unique upon joining the Krembo Wings family.',
    STORY_LINK: 'Our YouTube channel',
    PARTNERS: 'Our Partners and Supporters',
    DONATE: 'Make a donation',
    FULL_LIST: 'Full List',
    AWARDS_H1: 'Awards and Honors',
    AWARD1: 'The Tamari Award (currently the Ramon Award) for quality, leadership, and excellence',
    AWARD2: 'The Bernstein Award – in memory of Sylvia Bernstein – for volunteering and social leadership',
    AWARD3: 'Worthy Citizen of the City of Hod HaSharon, Lions Israel Award – for Adi Altschuler, founder of Krembo Wings',
    AWARD4: 'One of ten Entrepreneurs of the Year Awards, Ernst & Young with The Marker Magazine – to Adi Altschuler, founder of Krembo Wings',
    AWARD5: 'The Honor of Lighting the Torch on Israel’s 60th Independence Day, representing Israeli youth movements and volunteering youth',
    AWARD6: 'The Presidential Volunteer Award, for social-change leadership – to youth members of Krembo Wings',
    AWARD7: 'The Social Movement of the Decade, by Maariv Newspaper',
    AWARD8: 'The Effectiveness Award, given to Krembo Wings consistently every two years',
    AWARD9: 'The Ministry of Education, Southern District Award – to Haim Baumvell, Krembo Wings board member',
    AWARD10: 'The Yigal Alon Award for Exemplary Pioneering Social Activities',
    NEW_BRANCH_H1: 'Establishing New Branches',
    NEW_BRANCH_1_H2:
        'Each new branch brings joy and a sense of fulfillment to dozens of members',
    NEW_BRANCH_1_P:
        'Many of us have either been ourselves, members of a Youth Movement, or have enjoyed this special experience through our children, and thus are aware of the importance of such social activity for a child’s healthy development. Krembo Wings is a Youth Movement for children with disabilities, which allows there inclusion in social / educational activities with others.',
    NEW_BRANCH_1_P_2:
        'Children with complex disabilities find it difficult to develop a social life because of these challenges, such as communication difficulties, accessibility requirements and just because they are ’different’. These challenges make it problematic for them to meet with their peers, with and without disabilities, and thus they are unable to join any of the active Youth Movements in Israel.',
    NEW_BRANCH_2_H2: 'Our Branch activities',
    NEW_BRANCH_2_P:
        'Each branch holds a once-a-week activity for three hours in the late afternoon. Our model is to have individual counsellors working in a group framework. Each member has their own designated counsellors, usually two, who help and encourage the member to participate in each activity and in addition accompany and care for the member during the year.',
    NEW_BRANCH_2_P_2:
        'The member and their counsellors are also active in community work by volunteering together, are active in our democratic institutions and participate together in our annual Summer Camp.',
    NEW_BRANCH_3_H2: 'Our Branch activities',
    NEW_BRANCH_3_P:
        'Krembo Wings places paramount importance in opening branches in new areas, which it considers to be its civic duty. In each branch there are approximately 40 members and 100 counsellors who work with them.',
    NEW_BRANCH_3_P_2:
        'The new branches which we have opened, especially in the peripheries, are as a result of our fruitful co-operation with each local authority, which grants us the use of accessible premises. They also help fund the cost of bringing the members by specially adapted vehicles to and from each activity.',
    NEW_BRANCH_3_P_3:
        'Krembo Wings actively seeks to find supporters, both here and abroad, who will help to fund the opening of new branches. We believe that it is critically important to include all sectors of the community in our work.',
    NEW_BRANCH_STICKER:
        'The “Krembo Wings” movement was founded especially for children with disabilities. It is adjusted to their specific requirements and is accessible for all of them. ',
    krembo_wings: 'Krembo Wings',
    our_sections: 'Our projects',
    SUMMER_CAMP_H1: 'Summer Camp',
    SUMMER_CAMP_H2:
        'A summer camp specifically adapted for children and youth with disabilities',
    SUMMER_CAMP_H3:
        "כמו כל תנועות הנוער, גם תנועת 'כנפיים של קרמבו' מקיימת מחנה קיץ חווייתי לחניכיה. המחנה מותאם לכל החניכים, גם לחניכים עם צרכים מיוחדים.",
    SUMMER_CAMP1_H3: 'מחנה קיץ שהוא גם חופשה משפחתית',
    SUMMER_CAMP1_P:
        'במחנה הקיץ נהנים ומשתתפים, גם בני המשפחות של חניכים עם צרכים מיוחדים אנו רואים חשיבות רבה בשילוב בני המשפחות במחנה הקיץ, מתוך אמונה כי למשפחה תפקיד חשוב בהעצמת ילדים החיים עם צרכים מיוחדים מורכבים.',
    SUMMER_CAMP1_P2:
        'בנוסף, הורים לילדים עם צרכים מיוחדים מתמודדים מדי יום עם טיפול אינטנסיבי בצרכיו של ילדם ומתקשים לעמוד בהוצאות חופשה משפחתית שהופכת למורכבת יותר, הן מבחינה ארגונית והן מבחינה כלכלית. מחנה הקיץ של כנפיים של קרמבו מעניק למשפחות גיבוש משפחתי, מנוחה וחוויה משותפת.',
    SUMMER_CAMP2_H3: 'מתי מתקיים מחנה הקיץ ומה קורה בו',
    SUMMER_CAMP2_P:
        'המחנה מתקיים מידי שנה בחודש אוגוסט, בבית קיי בנהריה - אתר הנופש היחיד בישראל שבו כמות חדרים רבה הנגישה לכיסאות גלגלים. לאור הדרישה הרבה של המשפחות, מחנה הקיץ מתקיים בשלושה מחזורים.',
    SUMMER_CAMP2_P2:
        'הפעילויות במחנה מותאמות לכל המשתתפים באופן מודולרי, המשלב אותם יחד ולחוד בפעילויות נופש חווייתיות ומאתגרות: פעילות בבריכה, פעולות יצירה, ספורט, יוגה, תחרויות, הצגות, מופעים, קוסמים, קבוצות תמיכה למשתתפים ופעולות שמטרתן גיבוש חווייתי, הן של החניכים עם חונכיהם והן שלהם עם בני משפחתם. החונכים, אשר מבלים זמן ארוך ואיכותי עם חניכיהם, זוכים להכירם בצורה עמוקה יותר, מכירים את בני המשפחה הסובבים אותם ומאפשרים להורים זמן איכות לעצמם ולילדיהם האחרים.',
    SUMMER_CAMP_BTN: 'איך מצטרפים',
    SUMMER_CAMP_LEFT:
        'We never experienced a joint family vacation. It was the most rewarding and fun experience we had since our special son was born, 15 years ago!',
    TRAINIGN_H1: 'Training and Guidance',
    TRAINIGN_H2: 'Training and Guidance',
    TRAINING_P_1:
        'Krembo Wings is the only Youth Movement specifically designed to cater for children with complex disabilities. Our Youth Movement allows the members with disabilities, to participate in social and educational activities together with their counsellors who act as their intermediary in all activities.',
    TRAINING_P_2:
        'Our members are children and youth with disabilities aged 7 – 22. These youngsters are unable to join the other Youth Movements due to their difficult circumstances, and many of them are extremely lonely, an additional burden to bear on their disability.',
    TRAINING_P_3:
        'For many of our members with disabilities our activities are the only opportunity for them for any social activity outside of school. It also provides them with a unique opportunity for interaction with children without disabilities.',
    TRAINING_H3:
        'This may very well be the first time our members will have had an opportunity to meet their peers who also have disabilities.',
    TRAINING_P_4:
        'Our counsellors are required to participate in a wide ranging learning process in order to ensure that they are able to fulfill their role successfully.',
    TRAINING_P_5:
        'Our training and instruction courses cover all the positions in our movement, counsellors, branch leaders, leading team, in fact all that is required in order to ensure a smooth running organization.',
    TRAINING_P_6:
        'The development and expansion of our training program improves each individual’s performance and gives a strong feeling of belonging and loyalty, at all levels of involvement in our activities.',
    TRAINING_JOIN: 'איך מצטרפים',
    TRAINING_MILESTONES_H2: 'Training goals',
    TRAINING_MILESTONES_P_1:
        'Our aim is to give professional training and the tools required in order for our counsellors to have the ability to work with members with disabilities and to be able to communicate with them, if necessary using sign language.',
    TRAINING_MILESTONES_P_2:
        'The ongoing improvement of the capability and skills of our counsellors and branch leaders includes areas such as social skills, communication options, and team work.',
    TRAINING_MILESTONES_P_3:
        'Our training includes how to start and run a branch, the logistics required, how to attract and develop volunteers, management improvement, and the development of young counsellors to eventually play a leading role in their own social milieu and in the wider community.',
    TRAINING_MILESTONES_P_4:
        'We encourage interaction between branches which makes us stronger as a national movement as well as gaining the benefits from learning from others.',
    TRAINING_MILESTONES_P_5:
        'פיתוח מנהיגות צעירה של בני נוער כמובילי שינוי בסביבתם החברתית ובקהילה.    ',
    TRAINING_MILESTONES_P_6:
        'יצירת מערך פעילויות של הסניפים בקהילה, שמטרתו הובלת שינוי חברתי.',
    TRAINING_MILESTONES_2_H2: 'Courses and seminars',
    TRAINING_MILESTONES2_P1:
        'Krembo Wings organizes three annual seminars – at the beginning of the school year, in the middle, and at the end of the year. These are organized on both a local and national level. Each level also has its own specific seminar, for counsellors, team leaders, and branch leaders. There is also a national training day for all counsellors and leaders.',
    TRAINING_MILESTONES2_P2:
        'סמינר פתיחת שנה, אמצע וסוף שנה (מחוזי/ארצי) - לחונכים ולבעלי תפקידים.',
    TRAINING_MILESTONES2_P3:
        'סמינר מודולרי (מחוזי/ארצי) לבעלי תפקידים: צוותים מובילים, רכזים בוגרים ורכזי צרכים מיוחדים.',
    TRAINING_MILESTONES2_P4: 'סמינר הדרכה (מחוזי/ארצי) לצוותי ההדרכה.',
    TRAINING_MILESTONES2_P5: 'הכשרה חודשית (ארצי) לרכזי צרכים מיוחדים.',
    TRAINING_MILESTONES2_P6: 'יום חונכים תנועתי ארצי.',
    POLAND_H1: 'Poland Delegation',
    POLAND_H2:
        'A mission of Krembo Wings’ youth delegation to memorial sites in Poland',
    POLAND_P1:
        'In 2013 a number of our activists took upon themselves to initiate a‘Krembo Wings Mission to Poland’ and that the mission would include both members and counsellors. Behind the idea of visiting these memorial sites was the belief that such an important activity,representing the State of Israel in Poland by wearing our movementshirts, should also be made available for our members with special needs.',
    POLAND_P2:
        'As a Youth Movement, we believe that visits to these memorial sites is a powerful expression of our joint Jewish destiny and to do so aspart of a group enhances this experience. Our visit sends a strong message of support and acceptance from all sections of our society.',
    POLAND_P3:
        'Our Mission comprises 90 participants which includes our members with special needs, counsellors, parents of members and a 10 person logistic team. Participation in this special group is not taken lightlyand requires a long and thorough preparation period covering all the historic aspects required for such a visit.',
    POLAND_H3:
        'All the participants, including the parents, take part in all the preparatory stages including workshops and seminars, and visits to Yad Veshem and Kibbutz Lochamei Haghetaot.',
    POLAND_P4:
        'This Mission is expensive and in order to ensure that all our members are able to participate, whatever their financial situation, Krembo Wings raises funds to allow their participation.',
    SERVICE_H1: 'Pre-army social service year program',
    SERVICE_H2: 'Giving back to the community',
    SERVICE_P:
        'Since 2016 Krembo Wings has been operating 5 communes; in Upper Nazereth (now known as Nof Hagalil), Jaffa, Hod Hasharon, Kiriyat Gat and Beer Sheva. Each commune comprises 8 – 10 of what are termed Shnat Sherutniks. These are youngsters who have decided to give a ‘Year of Service’ to the community, prior to joining the army. The majority of them are counsellors who have been active in the movement for many years but each commune is open for anyone to join.',
    SERVICE_P2:
        'Together with the close involvement of the Local Municipality they are active in each community. The mornings are spent in schools helping children with special needs in their classroom and their afternoons are spent in the less formal educational frameworks such as After School Clubs, working with children at risk. In addition they are all closely involved in the running of their local Krembo Wings branch.',
    SERVICE_H3:
        'The approximate running cost of each commune is estimated to be NIS150,000 per year.',
    PARTICIPANTS_H1: 'Members',
    PARTICIPANTS_H2: 'Funding members with disabilities',
    PARTICIPANTS_P:
        'In order to be able to accept into our activities a member with special needs, we are required to provide a wide-ranging support framework.',
    PARTICIPANTS_H3:
        'The cost of accepting and absorbing a member with special needs into our Youth Movement is approximately NIS4,500 for the year.',
    PARTICIPANTS_P2_SMALL: '',
    PARTICIPANTS_P2:
        'This sum includes all necessary expenses such as special communication equipment, providing activities that enable all members to participate, various materials for activities. Each branch arranges outings such as going to shows. Krembo Wings also organizes several national activities such as our Summer Camp which is open to all and has several cycles in order to accommodate all our members, and a national get together for all our counsellors.',
    PARTICIPANTS_H2_2: 'Insurence',
    PARTICIPANTS_P3:
        'One of the more important and expensive aspects we are required to pay are the necessary insurances required to cover all facets of our activities and this comes to an annual figure of NIS150,000.',
    PARTICIPANTS_H2_3: 'Uniforms',
    PARTICIPANTS_P4:
        'Similar to all other Youth Movements we too have our own special uniform, which we see as a symbol of equality and unity. Our uniform is a light blue shirt with our badge and a brown tie. The shirt has been designed so that it is able to be worn by all our members whatever their disability. The shirt and tie are usually bought at the beginning of each years’ activity at a nominal cost of NIS50 per member while the true cost to be covered by Krembo Wings for all members and counsellors is NIS250,000.',
    PARTICIPANTS_H2_4: 'Uniforms',
    PARTICIPANTS_P5:
        'We make our activities accessible to all by arranging special transport facilities. We transfer the member from his home to participate in the branch activity and then return him back home. This is a very expensive but essential part of our activities and the annual cost can be NIS35,000 for a local branch and reach NIS100,00 when it is a regional branch.',
    PARTICIPANTS_btn: 'Member registeration',
    special: 'Special gratitude',
    sliderHebrew: false,
    langString: 'en',
    TOP_PAGE_H2:
        'Youth movement for children and youth with and without disabilities',
    TOP_PAGE_NUTTON_DONATE: 'Make a Donation',
    TOP_PAGE_NUTTON_SIGNUP: 'Register',
    TOP_PAGE_NUMBERS_RIGHT_H2: 'Activists',
    TOP_PAGE_NUMBERS_LEFT_H2: 'Branches',
    TOP_PAGE_NUMBERS_RIGHT_H3: 'In the youth movement “Krembo Wings”',
    TOP_PAGE_NUMBERS_LEFT_H3: 'Nationwide, many more are planned',
    BIG_VIDEO_H1: 'Eyal Kitzis makes wings for Krembo',
    VIDEO_SECTION_P1: `Imagine your world without friends. Can you fathom such a world? That's the reality that thousands of children with disabilities wake up to every day.`,
    VIDEO_SECTION_H2:
        'Krembo Wings is now embarking on a fundraising campaign using the PayBox app',
    VIDEO_SECTION_PAYBOX: '',
    VIDEO_SECTION_P2:
        'In order to finance the opening of new branches for the 3000 children with disabilities currently waiting to join our accessible and inclusive social network, and find the friendships they so sorely lack.',
    MAIN_PAGE_HEADING_PART_1: `More than 3000 children with disabilities are waiting to join`,
    MAIN_PAGE_HEADING_PART_2: 'Krembo Wings',
    values_h1: 'Our Values',
    value1_h3: 'Leading a Social Change',
    value1_p:
        'Krembo Wings is a youth movement for children and youth with and without disabilities. Yes, we are a youth movement in every sense of the word, and members of the movement do not view their activity as “volunteer work”, but as an experiential social activity – for themselves and for others.',
    value2_h3: 'Conducting Socio-Educational Activities',
    value2_p:
        'Our members convene weekly informal social-educational activities in the evenings, based on the model of personal counseling in a group environment. Most of our counselors are youth who study in mainstream schools. The joint activities promote awareness of populations with disabilities and of social inclusion. ',
    value3_h3: 'Creating a Meaningful Place for Everyone',
    value3_p:
        'We believe that all children, regardless of their capabilities, ethnicity, religion, or gender share a common need – they all want and need to experience social belonging, and every child deserves joyful time spent with friends.',
    value4_h3: 'Commitment to Full Accessibility',
    value4_p:
        'We are committed to providing a fully accessible venue for our activities. We provide accessible transportation for members from their homes to the venue and back in vehicles geared for people with disabilities, supervised and accompanied by a Krembo Wings member. We provide nursing services by trained nursing professionals who assist members with their intimate needs during our activities.',
    vision_header: '’Krembo Wings’ Vision Statement',
    create_h2: 'Creating a Meaningful Place for Everyone',
    create1_h3: 'This vision reflects the movement’s spirit and ethical code:',
    create1_p:
        'Creating together a significant, beneficial, and empowering place for each and every member, with or without disabilities,',
    create2_h3: 'regardless of social and cultural background.',
    create2_p:
        'Krembo Wings members are the future generation who will shape Israeli society and pass on the values of social equality, demonstrating care for the wellbeing of all Israeli populations and communities.',
    create3_h3:
        'The movement’s mission is to establish a Krembo Wings branch in each and every community in Israel,',
    create3_p:
        'so as to provide equal opportunities, social life, and a sense of belonging for each and every child with special needs – regardless of their cultural background, socio-economic status, religion, or gender. The movement also works to change perceptions of and attitudes towards people with disabilities in Israeli society.',
    circle1_h3: 'I Am a Friend – Mutual Commitment ',
    circle1_p:
        'To take care of one another. To accept the fact that no one is perfect. To respect one another and each person’s capabilities. To help, support, accept, and interact.',
    circle2_h3: 'I Love – “Love your fellow as yourself”',
    circle2_p:
        'To love by understanding and with the ability to accept any situation, even when it is hard. To always look on the positive side of things and to act out of joy.',
    circle3_h3: 'I Am Israeli',
    circle3_p:
        'Krembo Wings was founded in Israel, based on the Israeli values of mutual responsibility and helping the other. Krembo Wings members come from all backgrounds of Israeli society. We lead Israeli society towards a change in its perceptions of and attitudes towards people with disabilities.',
    circle4_h3: 'I Belong – Belonging, Inclusion, Mutuality',
    circle4_p:
        'Each and every one of us works to fulfill their potential and is a collaborative participant in our activities. It is our mission to support and enable everyone to fulfill their potential. We should learn how to help others and how to receive help',
    circle5_h3: 'I Can – Abilities and Independence',
    circle5_p:
        'I believe in myself, in my ability to influence others and to lead change, and in my choice to be independent',
    circle6_h3: 'I’m a Leader – Commitment, Responsibility, and Leadership',
    circle6_p:
        'Each and every one of us is a leader. Every one of us can bring about change, and together all of us can lead a social change',
};
exports.PARENTS = {
    YEARS_ARR,
    DAYS_ARR,
    PARENT1_H1: 'הורה 1',
    NAME: 'שם מלא',
    PHONE: 'מספר טלפון',
    COUNTRY: 'ארץ לידה',
    YEAR: 'שנת עליה',
    EMAIL: 'דוא”ל',
    WORK: 'מקום עבודה',
    PARENT2_H1: 'הורה 2 (לא חובה)',
    SIGN: 'חתימה',
    TAKANON:
        '        הנני מתחייב להודיע לרכז הבוגר הסניפי על כל שינוי או הגבלה זמניים / קבועים שיחולו במצב הבריאותי של בני/בתי לרבות קבלת חיסון ו/או החלמה מנגיף הקורונה.',
    SIGN_NAME: 'שם הורה מאשר',
    TAKANON_TEXT: 'תקנון האתר',
    TAKANON_LINK:
        'https://www.krembo.org.il/static/media/%D7%AA%D7%A7%D7%A0%D7%95%D7%9F%20%D7%94%D7%A2%D7%9E%D7%95%D7%AA%D7%94.219c38a9.pdf',
    WITH_MOUSE: 'צורו חתימה עם העכבר',
    RESET: 'איפוס חתימה',
    NEXT: 'המשך לתשלום',
    ERROR_MSG: 'שדה חובה',
    ID: 'ת״ז הורה מאשר',
    ERROR_SIGN: 'חתימה חסרה',
    TAKANON2: 'אני מאשר/ת שקראתי את',
    TAKANON2_1: 'תקנון התנועה ',
    TAKANON2_2: ' להלן ומקבל/ת כל התנאים הכתובים בו',
    TAKANON2_2_LINK:
        'https://www.krembo.org.il/static/media/%D7%AA%D7%A7%D7%A0%D7%95%D7%9F%20%D7%94%D7%A2%D7%9E%D7%95%D7%AA%D7%94.219c38a9.pdf',
};
//////////From Press page////////////
exports.press = {
    PRESS_H1: 'Press',
    PRESS_SIGAL_BTN: 'Contact',
    PRESS_HEADER_NAME: 'Sigal Dekel',
    PRESS_HEADER_POSITION: 'Public Relations Manager',
    PRESS_HEADER_TEXT_1:
        'Sigal has served as a joint owner and director of public and customer relations for a decade at Mythos Group, a leading Israeli company in the field of marketing and marketing event production.',
    PRESS_HEADER_TEXT_2:
        'In the past, Sigal served in various public-relations positions and as a spokesperson in leading organizations and companies, such as Arad Communications, Shion Communications and Advertising, and Shira Shkolnik Communications and Advertising.',
    PRESS_HEADER_TEXT_3:
        'She is a graduate of Tel Aviv University, with a bachelor’s degree in media studies, and has been serving as Krembo Wings’ public relations manager since January 2014.',
    PRESS_HEADER_CONTACT: 'Contact Us',
    PROJECTS_H1: 'Krembo Wings’ Projects and Collaborations',
    PROJECT1_TITLE: 'The Story of the Arabic-speaking Branches',
    PROJECT1_TEXT:
        'The story of Krembo Wings branches in the Arab community – the connection between different communities, and the importance of their integration into all Israeli populations.',
    PROJECT2_TITLE: 'Thanking IKEA',
    PROJECT2_TEXT:
        'Young members of Krembo Wings thank IKEA for its long-lasting support of the movement, enabling us to continue and establish more branches across Israel.',
    PROJECT3_TITLE: 'The Krembo Anthem Video Clip',
    PROJECT3_TEXT:
        'The Krembo Wings anthem reflects the vision and spirit of our movement. It was written by Noam Horev, and performed by Bisan Abu Laban and Shay Hamber, together with Krembo Wings members.',
    PROJECT4_TITLE: 'A Legendary Summer Camp – August 2015',
    PROJECT4_TEXT:
        'Krembo Wings’ summer camp offers joyful days for its participants, strengthening the feeling of unity between members of the Krembo community.',
    PROJECT5_TITLE: 'On a Special Journey to Poland',
    PROJECT5_TEXT:
        'A news story broadcasted on Channel 1 about the Krembo Wings’ unique delegation to Poland. ',
    PROJECT6_TITLE: 'The Song “Equals” in Sign Language',
    PROJECT6_TEXT:
        'The song “Equals” by Elai Botner and Ran Danker performed entirely in sign language by Krembo Wings counselors from the Kochav Yair-Tzur Yigal branch',
    PROJECT7_TITLE: 'Champions’ Honor',
    PROJECT7_TEXT:
        'Thanks to Krembo Wings and in collaboration with the Israeli Professional Football Leagues, 21-year-old Yoel Sabir fulfilled his dream and scored a goal to HaPoel Be’er Sheva’s goalie, enjoying the cheers of hundreds of football fans. ',
    PROJECT8_TITLE: 'Opening a New branch with Amos Tamam',
    PROJECT8_TEXT:
        'A crowdfunding campaign video to open a new Krembo Wings branch in Ramla, presented by Amos Tamam. Within a month, we managed to raise nearly 200,000 NIS.',
    PROJECT9_TITLE: 'National Counselor Day',
    PROJECT9_TEXT:
        'The singer Rotem Cohen in a moving sign-language version of his song “Into Your World” together with thousands of Krembo Wings members.',
    PAPER_H1: 'Press ',
    PAPER1_TITLE: 'Order of the Wings event for the Israeli First Lady',
    PAPER1_TEXT:
        'Nehama Rivlin, Israeli First Lady, movingly recounts the Order of the Wings event at Krembo Wings’ Jerusalem Branch.',
    PAPER2_TITLE:
        'The Beautiful Face of Israel Krembo Wings at the United Nations',
    PAPER2_TEXT:
        " ​(היום הבינלאומי לשוויון זכויות לאנשים עם מוגבלויות​) על מאי אופיר, החניכה הראשונה בקרמבו ועל הנאום שנשאה באו'ם, במסגרת משלחת מיוחדת של 'כנפיים של קרמבו' ​שהוזמנה לשאת את בשורת...",
    PAPER3_TITLE: 'For my daughter this is the pinnacle of her summer',
    PAPER3_TEXT:
        '(לקראת אירוע ההתרמה) מיכל פעילן על "מחנה הקיץ" של קרמבו ועל אירוח השר בנט במהלכו. "בלי קרמבו כנראה שלא יכולתי לחיות" – מיכל חניכה עם שיתוק מוחין מיבנה.',
    PAPER4_TITLE: 'Winning Together',
    PAPER4_TEXT:
        "כתבת שער במוסף 'שישבת' על קומונת תל אביב של 'כנפיים של קרמבו', הקומונה המשולבת הראשונה בישראל.",
    PAPER5_TITLE: 'מישהו לעוף איתו',
    PAPER5_TEXT:
        '(לקראת אירוע ההתרמה) חגית רון רבינוביץ על אפיק סופיר - חונך מקריית גת עם עיוורון ושיתוק מוחין ועל החניכה שלו רותם שנמצאת על הרצף האוטיסטי.',
    PAPER6_TITLE: 'משפחה עם כנפיים',
    PAPER6_TEXT:
        '(לקראת אירוע ההתרמה) חגית רון רבינוביץ על יהודית טוויטו מצפת - אם אומנה לעשרות ילדים ובניהם אבירם חניך בקרמבו שהפך למדריך לילד על הרצף האוטיסטי.',
    PAPER7_TITLE: 'מתקשר רק באמצעות מבע פניו - ומאושר.',
    PAPER7_TEXT:
        '(לקראת אירוע ההתרמה) אמלי עמרוסי על תמרה, עולה מדרום אפריקה, אם חד הורית מיבנה, ועל בנה כניה חניך בקרמבו עם שיתוק מוחין שמתקשר רק באמצעות מבע פניו.',
    PAPER8_TITLE:
        'The person that taught the Arab and Bedouin communities to help special needs children',
    PAPER8_TEXT:
        '(יום האישה הבינלאומי) הצעירה שלימדה את המגזר הערבי הבדואי - חיתאם אבו-בדר, מייסדת ומנהלת המחוז הרב תרבותי בקרמבו, פתחה סניפים…',
    PAPER9_TITLE: '"מגיעים לי חברה, אהבה, צחוק ומשמעות”.',
    PAPER9_TEXT:
        '(כתבת פרומו לקמפיין בהדסטארט עם עמוס תמם, לטובת גיוס תרומות להקמת סניף קרמבו ברמלה) פז סולטנוביץ, בת ה- 15, חונכת עם שיתוק מוחין בסניף קריית אונו "קרמבו שינו לי את החיים"',
    PAPER10_TITLE: 'הכניסיני תחת כנפך: הנשים מאחורי התנועה "כנפיים של קרמבו”.',
    PAPER10_TEXT:
        '"הנשים מאחורי תנועת הנוער "כנפיים של קרמבו"- לרגל יום האישה הבינלאומי',
    PAPER11_TITLE: 'לנצח דרקונים.',
    PAPER11_TEXT:
        '(ראש השנה) "לנצח דרקונים" ביקור פעילי קרמבו בגן לילדי מהגרים בדרום תל אביב. ככה מנצחים דעות קדומות ומקרבים לבבות.',
    PAPER12_TITLE:
        'כל הדרך לאו"ם: "כנפיים של קרמבו עושה מהפכה חברתית שקטה, אבל עצומה”.',
    PAPER12_TEXT:
        '"תנועת הנוער המקומית כנפיים של קרמבו רשמה הישג חסר תקדים עם בחירתה ליועצת לארגון ECOSOC של האו"ם בתחום השילוב וההכלה."',
    PAPER13_TITLE:
        "התאומים טומי ויאן ברצ'נקו במהדורת חדשות מרכזית ערוץ 10 'שווים' עם מאיה איידן.",
    PAPER13_TEXT:
        '(היום הבינלאומי לזכויות לאנשים עם צרכים מיוחדים) "שווים" - מאיה איידן עם התאומים טומי ויאן מקרמבו (מדקה 0:53 - בקטעים עד סוף הכתבה)',
    PAPER14_TITLE: 'פורשים כנפיים',
    PAPER14_TEXT:
        '(ערב יום השואה) כתבה על משלחת קרמבו למסע זיכרון מיוחד ונגיש לפולין.',
    PAPER15_TITLE: '15 שנים להיווסדות התנועה',
    PAPER16_TITLE: 'גוליבר וקרמבו נפגשים',
    PAPER17_TITLE: 'כנפיים של קרמבו ושל אפל',
    PAPER18_TITLE: 'ניר ברונשטיין באום',
    PAPER19_TITLE: 'תצוגת האופנה',
    MAGAZINE_H1: 'Krembo Magazine',
    MAGAZINE1_NAME: 'Magazine No. 2',
    MAGAZINE1_DATE: 'September 2015',
    MAGAZINE2_NAME: 'Magazine No. 3 ',
    MAGAZINE2_DATE: 'May 2016',
    MAGAZINE3_NAME: 'Magazine No. 4',
    MAGAZINE3_DATE: 'January 2017',
    MAGAZINE4_NAME: 'Print Magazine',
    ACTIVITY_h1: 'אירועי התרמה - קרמבו של קיץ',
    ACTIVITY_PROJECT1_TEXT: 'קרב הדיוות הגדול',
    ACTIVITY_PROJECT2_TEXT: 'קיציס ואירנה חולמים קרמבו',
    ACTIVITY_PROJECT3_TEXT: 'פאודה – גרסת קרמבו',
    ACTIVITY_PROJECT4_TEXT: 'ירון ברלד מחקה את נינט',
    ACTIVITY_PROJECT5_TEXT: 'משיח" וקרמבו של קיץ"',
    ACTIVITY_PROJECT6_TEXT: 'מופע הסטנד אפ של  עדי גולדשמיט',
    view: 'view',
    STORY_LINK: 'Our YouTube channel',
    isHebrew: false,
    langString: 'en',
    engPaper2Translation: `The youth movement delegation from Krembo Wings was invited to
    bring its message of social change, which it is leading in Israel, and
    explain its activities to the member countries of the United Nations.
    It was the International Day for Equal Opportunities for People with
    Disabilities and attending the session were Youth Delegations and UN
    Agencies working with the future generations.
    The UN headquarters chose to place the subject of the integration
    into general society of people with difficulties on the world agenda in
    2015. Representatives of Krembo Wings, the only Youth Movement
    in the world that integrates in its social activities youngsters with and
    without disabilities, had been invited to the UN with the aim of
    revealing its mode of operation and also in order to bring the
    message of social change and equal opportunities for all in the
    framework of a Youth Movement that caters for youngsters with and
    without disabilities.
    Participating in the delegation were Nir Bronstein, Chairman of
    Krembo Wings, Hadass Shtenger, Head of the Training Division, and
    Mai Ophir, a member of the Hod Hasharon branch. The members of
    the delegation spoke in the framework of a discussion on “Bridging
    the Gap – social involvement of youngsters with disabilities”.
    Mai Ophir, aged 17, told the audience, “Krembo Wings is the only
    place where I am not judged by my appearance. I understand that it
    is difficult for people to look at me because of my disability.
    Separation between children causes alienation and isolation, and this
    is some ting we must change, and quickly, because everyone
    deserves a social framework”.
    Nir Bronstein, Chairman of Krembo Wings, and father of 15 year old
    Tal, his daughter with disabilities and a member of Krembo Wings
    added “One day, Noam, Tal’s sister, brought home a friend. As their
    father I was worried how Noam would introduce her disabled sister
    and whether she would feel any embarrassment. Noam was showing
    her round the house. She entered Tal’s room and quite openly
    explained that she was her sister, and that she didn’t talk, but that
    she is charming and much loved. At that moment I understood two
    things, firstly that Noam was not in any way embarrassed and that for
    her to be Tal’s sister was absolutely normal. But more importantly I
    learned that children, have a far better understanding and acceptance level than adults, and as such they are better equipped to
    lead social change and to make this world a better place, just as
    thousands of youngsters, with and without difficulties are doing in
    our Youth Movement Krembo Wings”.`,
    engPaper4Translation: `They live together in a crowded flat in Tel Aviv each learning to live 
     with the others disabilities and they are all there in order to work
    with children in the Special Needs School System. Eleven youngsters,
    members of the Krembo Wings Youth Movement, three of whom are
    on the Autistic Spectrum, one with Cerebral Palsy, but all of whom
    decided to give a “Year of Service’ in this first of its kind commune.
    Something really annoyed Yaheli, an 18 year old on the Autistic
    Spectrum in the small jammed ground-floor communal flat of
    Krembo wings in South Tel Aviv. It was a simple request, to tidy up
    their joint lounge, but it was something which made him lose his cool
    and shout in frustration. “It was my turn to tidy up but I hadn’t a clue
    what to do” he explained. “I simply do not understand concepts such
    as ‘clean’ and ‘orderly’. I don’t understand why others think it is a
    mess. I asked what to tidy up and where things go but no-one
    answered me. I asked again and once more I was ignored so I didn’t
    bother cleaning up. Then one of the girls asked me why was I not
    tidying the lounge so I shouted at her – My dear, how am I meant to
    tidy up if you don’t explain to me what needs doing”.
    So she said “why do I need to explain to you” and went off in tears to
    the girls’ bedroom. I needed to calm myself so I sat down and
    understood that the other commune members did not appreciate
    that for me things are different, that I am unable to comprehend
    simple social situations which for them are quite normal.
    After a couple of hours I knocked on her door and sat down opposite
    her, looked her straight in the eyes and said “I am sorry I shouted at
    you, I was just at that moment very confused”.
    Yaheli Pridan is one of the members of this Krembo Wings commune
    in which 11 youngsters, four of whom have special needs, will be
    doing their year of service. This is a prototype to involve youngsters
    with special needs in such an activity. For the past year they have all
    lived together in a small flat in the Kiriyat Shalom neighborhood.
    During the day they work in Special Needs Schools. Together they
    face the struggles and challenges arising from the differences within
    their group, experience situations and crisis’s which they have never
    faced in the past, are exposed to special needs, but all the time are
    going through a complex process of accepting others.
    The commune has an annual budget of NIS350,00 which is covered
    by the Ministry of Education, Ministry of Defense, Tel Aviv
    municipality and by donations to Krembo Wings.
    Their flat has two bedrooms, for the four boys and seven girls, a
    lounge and kitchen, one shower and two toilets. When I met them in
    the afternoon, the lounge had already been tidied. Meital and Inbal
    had come to Yaheli’s help and together had made the place tidy.
    Now everyone was sitting on the couches and chairs – Yaheli, Meital,
    Almog, Inbal, Lotem, Shelo, Dennis, Tam, Taylor, Binna and Tal.
    Each of them come from a different part of the country, from
    Karmiel, Givat Yehoshua, Bnei Atarot, Nof Hagalil, Modi’in, Yokniam,
    Hadera, Givat Shmuel, Tsuriel, Rehovot and from Jerusalem. In a
    couple of weeks they will have completed an important year in their
    young lives and move on, some to the Army others to civilian service
    and they will be replaced by the next cycle.
    Lotem Hanoni was born with Cerebral Palsy. She has a limp and
    suffers when she has to stand for lengthy periods. She studied in the
    school system with the help of an assistant and was successful in her
    studies. “My teachers were so pleased to give me my graduation
    papers but socially it was very difficult for me. My peers did not
    accept for who I am, they saw that I limped and therefore thought I
    was weak, that I could not be part of their social group and that hurt
    me greatly. They did not mock me to my face but always looked at
    me as if to say where on earth did she come from, there were some
    days when I go home I burst out crying. My mother helped me all the
    time, encouraged me to continue and not to give up. Through her I
    understood that I am not the problem, I am what I am, it is the other
    children who are unable to appreciate the other and the different.”
    In tenth grade her life changed when her Mother took her to the
    local branch of Krembo Wings in Modi’in, to where they had
    moved after her Mother divorced.
    “From my first branch meeting I found my second home. Suddenly
    I felt, for the first time in my life, that I am an equal, that I am
    accepted with all my difficulties. You have absolutely no idea how
    that made me feel. I was in the clouds because all of a sudden I
    was surrounded by a supportive social framework and I felt my
    self-confidence growing. I was counsellor to a slightly backward
    sixth grade member and I felt I was doing something important.
    Then I was given another two members, one also slightly backward
    and the other was in a wheelchair. I gave them my heart because
    that is what I see in others. I am not judgmental but try to give
    each child the belief that he is not alone in this world, but rather
    that they can totally rely on me. My members became close to me,
    I become close to them – it was most empowering&quot;.

    Lotem was a Krembo counsellor for three years in her local branch
    and on graduation wanted to continue her involvement with
    Krembo Wings. She was fortunate because just then the decision
    was made to open the first diverse commune. Krembo Wings was
    established in 2002 with the slogan “together to make a
    meaningful place for all” to day operates some 65 branches from
    North to South with 6,000 active members, youngsters,
    counselors, coordinators, and other leaders. The idea of a
    commune was first mooted last year.
    “There was a groundswell demand for it from those with special
    needs who very much wanted to integrate into the Year of Service
    program” says 27 year old Gaya ben Sira, the Mother and Father
    of the Tel Aviv commune. “We understood that we needed to
    establish a commune in which we would be able to integrate
    youngsters with special needs. We knew it would be a big
    challenge and that it would require a sizable budget and that it
    would need my own personal involvement as well as that of a
    psychologist. As a movement which believes more than anything
    in the integration of youngsters with and without disabilities we
    decided that it was important to start this project and face
    whatever difficulties may arise”.
    Over 120 youngsters applied to be accepted for our first
    commune, including Lotem. But only 40 were able to be accepted
    for the communes which opened in Tel Aviv, Hod Hasharon, Kiriyat
    Gat, Beer Sheva and Nof Hagalil.
    “I wanted to continue in the movement for another year before
    volunteering for the army” says Lotem “I was interviewed for the
    commune by Gaya and Daniel (Daniel Ofek – responsible for the
    Krembo Wings Year of Service program) and when Gaya told me
    that I had been accepted I was both overjoyed and a little nervous.
    I was worried about living in a flat with 10 other youngsters I had
    never met and also form living away from my parents for the first
    time. I was concerned that they would not take into account my
    walking difficulties and that I would require extra sleep because of
    the efforts I would need to make. I am also very close to my
    Mother, who always cared for me, so that leaving her and home
    was a big move.”
    In August 2017 Lotem and 9 others arrived for their first day in the
    Tel Aviv commune. “In the beginning it was really difficult for me”
    she recalls “We had rows about every small issue, what to eat,
    where to shop and all sorts of silly things. And then I had my own
    personal issues. Sometimes they would urge me to walk quicker
    from the bus to home or to the shops, and this would upset me. I
    even rang my Mother and cried down the phone that here, of all
    places, they did not understand my disability”.
    “The others got angry with me, some thought I was not making a
    big enough effort, didn’t tidy up or cook, and it took me a long
    time to do more but in the end I learned. I learned to initiate, to
    join in and now I already know how to make whatever type of eggs
    are required even excellent pancakes, just ask anyone”.
    Meytal immediately nodded her head “Lotem makes great
    pancakes”.
    “One day, Inbal turned on the light and I got really angry as it
    woke me up and she was angry that I slept so much. I had to
    explain that I got tired easily and needed more sleep. One of our
    team, without special needs has other problems, everything
    worries her but none of us appreciated this difficulty. Any loud
    noise would disturb her even in the middle of the night.
    Sometimes we had to call Gaya to come and help. But after several
    incidents Gaya explained to us that she has a nervous disposition
    and we just needed to understand. That is the great thing about
    the commune, you learn to understand the difficulties of others. I
    feel that over time they all appreciated and accepted my
    difficulties. Today when we all go out together, we allow an extra
    15 minutes so we are not pressured for time and sometimes if we
    have been out late we come home by taxi to make it easier for me.
    I have also learned to live in a group, to make compromises, to
    realize that I am no longer living with my Mother. I have learnt to
    shop, to participate and contribute as much as I can”.
    In the mornings Lotem slowly walks to the bus stop, it takes her 12
    minutes and then by bus to her school in north Tel Aviv, as school
    specially for children with serious difficulties. She helps them get
    to their classrooms, feeds them at lunchtime and generally helps
    the teachers any way she can. At the end of the school day she
    returns to the commune, has something to eat and then goes to
    the Bat Yam branch of Krembo Wings and works helping the
    counsellors.
    Nineteen year old Almog Shimchon comes from Karmiel. Until last
    year she had never heard of Krembo Wings until she heard about
    them from a friend. She thought this would be a big challenge and
    decided to join. In the beginning she was worried about life in a
    commune “This living together concerned me. I had never worked
    before with people with special needs and was anxious as to how I
    would manage. I had too many preconceived notions. I was
    concerned that we would not be able to go out and have fun
    together, that I would need to look after them all the time. When I
    first got to the flat I was in shock. Not because of the special
    needs as I immediately saw they were well able to cope but
    because of the disgusting state of the flat. It was filthy. A
    different Youth Movement had used the flat previously and never
    tidied anything when they left.
    That first night I cried and we all slept together in the lounge as
    the bedrooms were not yet fit for use. It was difficult for me to
    understand the huge change in my life. After a few days we held
    our first joint evening activity in a nearby park. I sat and was bitten
    to death to such an extent that I had to return to our flat. Ten
    minutes later the whole group arrived back at the flat and said
    that if I couldn’t be with them then they would be with me.
    Suddenly I felt part of a group”.
    They all go home once a fortnight. “The first weekend I stayed in
    the flat” says Almog “I couldn’t stop cleaning everywhere and felt
    that all the others were doing nothing. I really got fed up with
    them all. It was only after a long session with Gaya and Lior (Lior
    Dayan our psychologist) that I realized the need for compromise
    and acceptance”.
    The notice boards are full of notes with instructions of what needs
    to be done including one long list of all the names and their
    special needs. One had written ‘I have severe OCD’ and another ‘I
    have changing moods’ neither of whom had been diagnosed with
    special needs. There is also a daily schedule and the evening
    options range from sundown on the beach, pizza evening, film,
    sushi night, and more.
    Almog continued “We have gone through a lot here. For instance I
    have learnt to sleep with the light on and to wait my turn for the
    shower when we come back from the beach. We have also got
    over our food issues as sometimes we argued over ridiculous
    things. At the beginning we did not talk about the fact that we
    were a mixed group – and that annoyed me – why not talk about
    the elephant in the room. We felt we could talk about anything
    but not about our special needs”.
    The commune leadership were also unsure as to whether it would
    be a good idea to hold such a discussion. However a couple of
    months ago they talked to all the youngsters and for Almog this
    was a huge relief. The discussion was open, frank and valuable to
    the group.
    Yaheli is sitting on the couch wearing a blue skirt, her movement
    shirt and sneakers “I have begun wearing a skirt recently. I suffer
    from sensitive skin and slacks bother me as do jeans. Generally I
    do not like being hugged and I hate noise. When 10 people all
    speak together it annoys me so I put on my headphones and go to
    my room. I also suffer from too much light and certain types of
    food. For instance I cannot eat salad so whoever is making
    breakfast prepares me something different so that I can also join
    in breakfast.”
    He grew up on Moshav Bnei Atarot with two older brothers. He
    speaks with great fluency while all the time playing with his hands
    and often doesn’t look you in the eye.
    “Up to third grade I went to a regular school but I got thrown out
    in the middle of the school year due to behavioral problems. Due
    to my social difficulties I began hitting other children so everyone
    distanced themselves from me. The headmistress really hated me.
    I was diagnosed in tenth grade everyone thought I was ‘hyper’
    with attention and concentration difficulties so I was given more
    and more Ritalin. It helped but made rather lethargic”.
    He studied in both regular and special needs schools “In the
    special needs schools the relationships between the pupils was
    quite appalling, we would shout insults at each other. In tenth
    grade I went back to a regular school and there I understood that I
    had to take myself in hand and make a serious effort to get on
    with the other pupils. I really suffered in school. There were tests
    when I never even went into the classroom as I knew I would fail
    miserably. And then I was diagnosed with Asperger which is on the
    Autistic spectrum. I then started to get all sorts of help. Oral tests,
    help with reading and on computers, they forgave my spelling
    mistakes, and so on. Suddenly the teachers understood my
    difficulties and so did I”.
    At age fifteen he joined the Krembo Wings branch in Yahud. “A
    good friend of my joined and persuaded me to come along. I
    never said what my difficulty was – It’s not that I have a problem
    talking about it but did not want to raise it immediately. I had a
    member called Orly who was also on the Autism spectrum. I
    helped her with all sorts of things, became close to her, and that
    was important for me. Despite all my difficulties it did not stop
    me from doing good and important things just like normal people.
    In the commune I have learnt something important, that there are
    people with obvious special needs and others where it is hidden.
    Each of us have our own particular disability”.
    For the entrance test for the ’Year of Service’ program despite his
    great motivation he was not accepted. Gaya explains “We were
    not aware he had been diagnosed, all we saw was that he had
    communication difficulties so we thought the commune would not
    be suitable for him”.
    But he did not give up and tried again. His school contacted
    Krembo and explained what his difficulty was and so a month later
    he was given another opportunity.
    “This time I brought my diagnosis with me and I spoke about my
    difficulties, about who I am, and also that I very much wanted to
    be accepted and to be accepted as part of the group, an equal
    among equals, and this time I was accepted.

    He describes his first day in the commune thus “It was as if I had
    landed on Mars. The flat, looking after ourselves, living with
    others in such a small flat – all seemed to me to be totally weird.
    In the beginning I was a loner as that id how I deal with new
    situations. On the other hand I am very vocal and make my
    opinion heard. I always thought that arguing helped me learn and
    develop, but this was unacceptable to the group so gradually I
    learnt to be more tolerant with others in the group. For instance
    one of our members observes Shabbat so we agreed we would
    leave a light on during Shabbat in the lounge and kitchen. The first
    Shabbat it really disturbed me as I need complete darkness to be
    able to fall asleep. So I found a book, went into the lounge and
    read all night long. But I needed to find a permanent solution for
    Shabbat so I completely covered my bed with sheets and blankets
    so that no light could penetrate and thus managed to sleep”.
    He also travels by bus every morning to the school to help the
    children with their studies and in general. “I help to feed them, to
    wheel about those on wheelchairs, whatever is needed. In the
    early afternoon I return to the commune, have lunch and a short
    rest, and then go out again. Part of the week I spend with ‘at-risk’
    children in Beit Danny which is in the Hatikva Neighborhood
    helping the basketball coach give lessons. The rest of the week I
    go to the Krembo branch in Ramat Gan”.
    I decided to accompany Yaheli and Inbal, an energetic and
    charismatic 19 year old from Jerusalem, on their way to the Ramat
    Gan branch. It was easy to see that the members who were
    waiting outside really love them. “Here’s Yahelli” one shouted
    “Wow, great haircut!” It was not difficult to feel and see Yahelli’s
    satisfaction while another of the members was busy hugging Inbal
    “I haven’t seen you for three whole days and I miss you”.
    Yahelli is going over the equipment list with one of the local
    leaders when he sees one of his favorites, someone with Downs
    Syndrome. “It really is so important that someone like this has
    such a supportive environment.”
    It is evening and all in the commune are summing up another long
    day. Inbal picks up her ukulele and begins to strum. Bina and Tal
    come to listen as do Taylor and Yahelli. Lotem is completely
    exhausted after her work in the Bat Yam branch. “This has been
    such a wonderful year for me” she says “I began with great fears
    and tears and here I am finishing up with great satisfaction and a
    great feeling. And by the way I have now volunteered for the Army
    and in three months I will be joining the Intelligence Corps.”
    I ask her for what position.
    That, she answers with big smile, is a secret.`,
    engPaper9Translation: `The decisive moment in the life of Hitam Abu – Bader occurred a few
    days after graduating from her school in the Bedouin town of Likia in
    the South. “I come from a community where it is not the done thing
    for young girls to be out alone in their village after dark and especially
    outside of the village” she says. “A few days after I finished high
    school I went to have fun in Beer Sheva with some school friends and
    when we had finished I rang my father and asked him to come and
    collect me. His answer was what’s the matter, they don’t have buses
    in Beer Sheva. You have to learn how to manage in this world and to
    look after yourself”.
    “This minor event actually had a huge impact on how I manage my
    life. Since that moment I know that everything is up to me and that
    no-one will control me, tell me what to do, what is allowed and what
    not. My parents taught me to believe in myself and my judgement
    and every day I thank them for that”.
    Her parents educated all their children to be ambitious and
    independent in complete contrast to the traditional conservative
    atmosphere in a Bedouin village. These attributes served her well as
    she forged her path in early adulthood as she was the first youngster
    to establish a Krembo Wings branch and began to integrate special
    needs children with their peers, as Krembo is the only Youth
    Movement that caters for both.
    Hitam became aware of Krembo Wings in her role as Youth Director
    in the large Bedouin town of Rahat, and as such was responsible for
    all kinds of volunteer programs for the youth of the town. “I was very
    ambitious with a strong will to succeed. I would spend hours on the
    internet looking for activities that would work in Rahat. And then I
    came across Krembo Wings so I rand them up and asked them to
    send someone to Rahat”.

    Thirty one year old Hitam was born in Likia, where her father had
    three wives and she has 16 siblings. Despite this large family and the
    wide age ranges, her parents ensured that they all got on well
    together, and they all remain in contact to this day.
    She began to become a social activist after school and volunteered
    for a year of service with the Scouts. She volunteered in villages in
    the south where there was no after-school informal educational
    framework. “I would visit these villages where there was great
    frustration about the lack of facilities and all the time I asked myself
    why is it that these children have no framework in the afternoons”.
    “Why can they not have what other children throughout the country
    enjoy. I then began to get involved in all sorts of volunteer projects in
    my community. In my community, children with special needs were
    considered sick and therefore there was absolutely no interaction
    with other children in fact they were even harassed. The idea of
    bring children with disabilities to the Youth Centre was unheard of”.
    She continued her Social Studies at Sapir College. “My parents were
    unable to support me financially but gave me great moral
    encouragement. Without their guidance I would not have dared to
    leave our village to study. I would travel every day by bus to college
    and felt proud I could do so”.
    After Hitam completed her studies she began her work in Rahat and
    subsequently brought Krembo Wings into the Youth Centre. “This
    was a big thing since the only framework for children with disabilities
    was the local school for children with special needs. No-one took
    these children into account and there were no activities available for
    them. There was a great deal of ignorance and shame about these
    children and the idea of having activities for them in our Centre was a
    complete revolution”.
    It was difficult at first for the residents of Rahat to accept Krembo
    Wings and many of the parents, both those of children with and
    without special needs, were fearful of sending their children to such
    an activity. But Hitam does not give up easily. “There was no
    appreciation of the needs of children with disabilities. In fact there is
    very little understanding of this complex problem in Bedouin society
    and when I introduced Krembo, while the children wanted to attend
    their parents were reluctant to send them.
    The idea that teenager was capable of looking after their disabled
    child was difficult for the parents to accept. It took a long time to get
    over their fears”.
    When the local Krembo branch opened Hitam left her position in
    Rahat and began to work in her current role as the Regional
    Coordinator for Krembo Wings. The success of the Rahat branch led
    to the opening of additional branches in Bedouin villages both in the
    South and the North. “There is a great feeling of satisfaction every
    time I open a new branch and it is difficult to express this feeling in
    words. In many of the Arab and Bedouin communities there are no
    activities of any sort for the youth. So while opening a Krembo
    branch in the Jewish sector provides an answer for children with
    disabilities, in many cases in the Arab and Bedouin communities this
    also provides an answer for all, and that is what is special about my
    work.” Hitam says that her work with children with special needs has
    changed her and to look on her life and surroundings in a different
    light.
    “When I first began working with the movement some four years ago,
    I was really quite unaware of the whole subject.
    I thought that children with special needs should remain in their own
    framework and I had no interest in what was happening with them.
    The first time I got to a special needs school I was quite terrified
    about entering. But then I started to arrange meetings between
    them and the volunteers and I was quite astounded at the results. I
    understood that if a 15 year old volunteer could meet up with special
    needs children who have difficulty in communicating and yet have a
    normal social experience – than there is no reason why I cannot. I
    was actually quite ashamed of myself. This feeling and experience
    was something I wanted to explain to the entire Arab and Bedouin
    community. I wanted them all to experience this feeling of shame
    and the barriers that exist are there to be brought down. I was able
    to show to the parents what progress their children with special
    needs made in such a framework and the parents were quite amazed
    at the difference in their children, they even contacted ne and told
    me how their children had changed.”
    Apart from having to break down these barriers, Hitam had to make
    many adjustments so that these meetings would be successful in the
    very conservative Arab and Bedouin society. “Our branches in Arab
    towns and Bedouin villages are different. Take for example the very
    conservative town of Arara, and when we opened the branch there
    the girls were not allowed out of their homes alone in the afternoons
    and they certainly were not allowed out to participate in hikes.
    And also girls were not permitted to volunteer with boys. Our ideas
    made the parents extremely worried and so we were required to
    make all sorts of changes to our program. For instance we shortened
    the length of our hikes and changed the times of our weekly
    meetings to make them suitable for where we were working. We
    made these changes as we were determined to succeed with this
    section of society. I met with all the parents and explained to them
    how we worked and the progress made by the participants with
    special needs which was entirely due to this hard work of the
    volunteers. All the parents were surprised at what their children had
    achieved and they contacted me and told me how their children had
    changed, and especially their girls. This for me was a very powerful
    message – that we could introduce change into even the most
    conservative of places”.
    “I believe that our local council heads must place the requirements of
    special needs children in the public discourse and that we must
    increase awareness on this subject and include all of those with
    special needs within our society. We have caused a revolution
    wherever where ever we operate and made the local population see
    things in a different light. These are changes we need to introduce all
    over and quickly especially in Arab and Bedouin society. When I visit
    one of our branches there, I feel that I am in a different world. It is
    quite impossible to describe when a child with Cerebral Palsy begins
    to communicate and to smile. Every child with special needs to be
    able to have this experience, be they Jewish or Arab.`,
    engPaper1Translation: `This week saw the beginning of our three day Summer Camp which is
    devoted to giving a special holiday to children with disabilities.
    Thousands of our members and counsellors met on the Golan Heights
    to participate in the annual Krembo Wings Summer Camp. This was
    an ideal way for them to end the summer break. “Here, they are able
    to enjoy a Summer Camp experience like participants in all the other
    Youth Movements”.
    Despite many efforts over the past few years, to formalize activities
    for children with disabilities and their parents during the summer
    holidays in a suitable framework, there is still no legislation covering
    this problem. Inevitably, whenever there is such a vacuum, then the
    various NGO’s such as LifeLine, Akim, Alut and others step in to fill
    the gap. All of them are dependent on donations to allow them to
    carry out their vital work. Krembo Wings is no different from any of
    the others in this respect.
    So this week saw the beginning of the annual Krembo Wings Summer
    Camp. Thousands of our members look forward to this annual event
    the whole year which is held at the Golan College in Moshav Hispen,
    which has been specially adapted to make it accessible to all.
    Together, members and counsellors, parents and family members
    will enjoy three days of action packed fun filled activity specially
    designed to allow all, irrespective of their disability, to join in the fun.
    The cost for this three day camp ranges from NIS2,000 to NIS5,000,
    as the activity has to be specially adapted to be accessible to all. This
    is a huge sum for most of these families, and due to this high cost and
    even with a special Krembo Wings subsidy, there remain some 3,000
    members we are unable to accept for budgetary reasons. Apart from
    the activities provided by various organizations, The Ministry of Social
    Welfare provide a very minimal subsidy for participation in summer
    camps. However this small subsidy is only available for certain places
    none of which are suitable for children who require accessibility.
    “Without Krembo Wings, these children would not have such an
    activity, they cannot go to the Scouts Summer Camp or any of the
    other Movements camps, but here they enjoy all activities just like
    everyone else” says member Tal Bronstein.
    “It’s great fun to go away for three days and to be able to enjoy
    oneself and to leave the ‘disabled’ feeling behind. Here I am accepted
    as an equal” says Michal, a summer camp participant. “This is the
    pinnacle of her summer” says Michal’s father Harel. “Since the end of
    school, she has been waiting for the Krembo Wings summer camp to
    begin. This is the first time that Michal has been able to enjoy a
    summer like any other child, because everywhere else accessibility
    problems prevent her from attending”.`,
};
exports.reports = {
    REPORT1: '2016 Audited Financial Report',
    REPORT2: '2016 Audited Narrative Report',
    REPORT3: '2015 Audited Financial Report ',
    REPORT4: '2015 Audited Narrative Report',
    REPORT5: '2015 Organization’s Top Five Salaries Report',
    REPORT6: '2014 Audited Financial Report',
    REPORT7: '2014 Audited Narrative Report',
    REPORT8: '2014 Organization’s Top Five Salaries Report',
    REPORT9: '2013 Audited Financial Report',
    REPORT10: '2013 Audited Narrative Report',
    REPORT11: '2013 Organization’s Top Five Salaries Report',
    REPORT12: 'Audited Financial Reports as of 31 December 2012',
    REPORT13: '2012 Audited Narrative Report',
    REPORT14: '2012 Online Organization’s Top Five Salaries Report',
    REPORT15: 'Audited Financial Reports as of 31 December 2011',
    REPORT16:
        'Audited Financial Reports as of 31 December 2011 (Narrative Report)',
    REPORT17: 'Organization’s Top Five Salaries Report 2011',
    REPORT18: 'Audited Financial Reports as of 31 December 2010',
    REPORT19:
        'Audited Financial Reports as of 31 December 2010 (Narrative Report)',
    REPORT20: '“Ishur Nikui Mas” – Tax Deduction Certificate',
    REPORT21: '“Ishur Nihul Pinkasim” – Bookkeeping Certificate',
    REPORT22: '“Ishur Nihul Takin” – Certificate of Proper Management 2019',
    REPORT23: 'Form no. 46 until December 2020',
    REPORT24: '"Krembo Wings" Statute',
    REPORT25: 'Personal Accident Insurance Policy',
    REPORT26: '"Krembo Wings Double Dream" Activity Terms',
    REPORT27: 'חוזר למחנה קיץ 2019',
    REPORT28: 'טופס ביטול הרשמה למחנה קיץ 2019 וורד',
    REPORTS_H1: 'Financial Reports',
    LANGUAGE: 'eng',
    ishurim: 'Approvals',
    appendixes: 'Appendixes',
    view: 'view',
    reports: 'Reports',
    ishurFilter: 'Ishur',
    takanonFilter: 'Krembo Wings',
    takanon: 'תקנון העמותה',
    tisa: 'תקנון הגרלת כרטיסי טיסה',
};
////////// thankyou page ///////////
exports.thanks = {
    BTN: 'Back to home page',
    success: 'Your request has been submitted',
};
exports.event = {
    form_h1: 'Destination of donation',
    form_h2: 'Fundraiser - Yuval sings 2019',
    form_h3:
        '*All funds are used as a donation for the children of "Krembo Wings"”',
    name: 'Full name/company',
    phone: 'Phone number',
    email: 'Email address',
    id: 'ID/Corporate number ',
    id_error: 'Enter ID/Corporate number',
    messgae: 'Notes',
    send: 'צור קשר',
    managers_h1: ' Management',
    name_fill: 'Enter full name',
    phone_fill: 'Enter phone number',
    email_fill: 'Enter email address',
    subject_fill: 'אנא בחר נושא',
    bad_phone: 'Invalid phone number',
    bad_email: 'Invalid email address',
    send_succeded: 'בקשתך נשלחה',
    newlatter_p:
        "I approve recieving mail and/or promotions from 'Krembo Wings'",
    round_up_p:
        'I would like to donate via Igul Letova for the "Krembo Wings"  foundation',
    ticket_type: 'Ticket type',
    ticket_500: 'Balcony 500₪',
    ticket_750: 'Hall 750₪',
    ticket_1800: 'Krembo friends 1800₪',
    ticket_amount: 'כמות כרטיסים',
    ticket_total: 'Total',
    tickets_aside:
        '*Tickets will await purchasers in the ticket booths on the day of the event',
    tickets_submit: 'Continue to donation',
    till: 'Show begins in',
    minutes: 'Minutes',
    hours: 'Hours',
    days: 'Days',
};
exports.donate = {
    header: `Let's ensure that all children are friends, let's create a place and meaning for each person.`,
    form_h1: `It's really short - start here:`,
    this_way: 'Or you can either:',
    first_box_h2: 'Phone our call center',
    first_box_p: '077-9555547 or our office at 09-8852385',
    second_box_h2: 'Write a check',
    second_box_h5: `Our Address - 17 Ha-Nevi'im St. 1166 4727919 PO Box 1166`,
    second_box_p_1: 'For',
    second_box_p: '“Krembo Wings” ',
    third_box_h2: 'Transfer to',
    third_box_h5: `Bank Hapoalim (12), Sha'ul HaMelech Branch (532) Daniel Frish Street 3 Tel Aviv Account No 665538`,
    third_box_p: 'Krembo Wings Account',
    language: 'english',
    h1: 'Join us',
    text1: 'Thank you for helping us fulfill our vision – to create a meaningful place for everyone, and to allow each and every child, with or without special needs, to enjoy meaningful, enriching social activities in our youth movement, Krembo Wings. With your help, we can enable these children to realize their dreams, allow their families a few hours of respite and quality time with their other children, and provide Krembo Wings’ counselors with an empowering, rewarding experience.',
    small_text:
        'Secure donation – We take all precautions and use strict security settings to ensure a secured, safe donation payment.',
    options: 'Donation Options',
    options_text1: 'On the phone through our answering service +972-77-9555547',
    options_text1_1: 'Or through our main office +972-9-8852385',
    options_text2: 'Or with a check paid to the order of ',
    options_text2_1: 'Krembo Wings',
    options_text2_2:
        'Our address 17 HaNeviim St.,  Ramat HaSharon 4737919  PO box 1166 Israel ',
    options_text4: 'A bank transfer to',
    options_text4_1: 'Krembo Wings bank account',
    options_text4_2: 'Bank HaPoalim (12)',
    options_text4_3:
        'Shaul HaMelech Tel Aviv Branch (532)Account number 665538',
    options_text3:
        'Round Up is an initiative that enables you to do good every day',
    options_text3_1:
        'Join Round Up today, and with each transaction that you make with your credit card, the sum will be rounded up to the nearest amount (in NIS). The rounded sum will be donated entirely to Krembo Wings.',
    join: 'Join today and start Rounding Up your good deeds',
    destination: 'Purpose of donation',
    destination_1: 'General',
    destination_2: 'Poland Delegation',
    destination_3: 'Summer Camp',
    destination_4: 'Training and Guidance',
    destination_5:
        'Adopt an activist or guide  - with or without special needs',
    destination_6: 'Art',
    person_details: 'Receipt addressed to',
    name: 'Full name/company',
    phone: 'Phone number',
    address: 'Address',
    city: 'City',
    email: 'Email address',
    id: 'ID/Corporate number ',
    notes: 'Notes',
    form_holiday_card: 'Choose a Greeting',
    or: 'or',
    keva: 'Make a monthly donation using a bank order – quick and easy!',
    submit: 'Continue to donation',
    project: 'Purpose of donation',
    name_insert: 'Please insert first and last name',
    phone_insert: 'Please insert a phone number',
    address_insert: '   ',
    city_insert: '',
    email_insert: 'Enter email',
    id_insert: 'Please insert id/Corporate number',
    insert_total: ' Enter amount',
    bad_email: 'Invalid email ',
    bad_phone: 'Invalid phone number ',
    amount: 'Amount',
    min_amount: 'סכום מינימלי 1 ש"ח',
    chose_project: 'Destination of Donation',
    newlatter_p:
        "I approve recieving mail and/or promotions from 'Krembo Wings'",
    round_up_p:
        'I would like to donate via Igul Letova for the "Krembo Wings"  foundation',
    general: 'General',
    who_to_send_holiday_card_to: 'Who is the recipient?',
    who_sent_it_holiday_card_to: 'Who is the sender?',
    receiver_email: `Recipient's Email`,
    receiver_name: `Recipient's Name`,
    sender_email: `Sender's Email`,
    choose_a_blessing: 'Please choose a card',
    sender_name: `Sender's Name`,
    blessing: 'Add a personal message (optional)',
    generalWarningMessage: 'Please fill out the missing information',
};
exports.branches = {
    h1: 'List of branches and activity hours',
    search: 'Search for a branch',
    activity_day: 'Activity day',
    working_hours: 'Joint activity hours ',
    activity_day_senios: 'Counselor activity day',
    branch_manager: 'Branch Manager',
    senior_manager: 'Adult Coordinator',
    managers_h1: 'Executive Committee',
};
exports.PERMISSIONS = {
    DISABILITY_H1: 'מגבלות רפואיות',
    DISABILITY_ARR: [
        {
            text: 'אני מצהיר כי לבני/בתי אין כל מגבלה בריאותית',
            value: false,
        },
        {
            text: "לבני/בתי מגבלות בריאותיות / רגישויות הדורשות התייחסות מיוחדת או מונעות השתתפות בחלק מהפעילות (כגון אסטמה, סכרת נעורים וכו')",
            value: true,
        },
    ],
    DISABILITY_PLACEHOLDER: 'פירוט המגבלות הבריאותיות',
    ALERGY_H2: 'לבני/בתי יש אלרגיה',
    ALERGY_PLACEHOLDER: 'לבני/בתי יש אלרגיה מסוג:',
    ALERGY_PLACEHOLDER2:
        "מה גורם להתקף האלרגיה/רגישות (למשל אכילה, מגע, חשיפה לריח וכד') ",
    ALERGY_PLACEHOLDER3: "במה מתבטא ההתקף( למשל קוצר נשימה, גירוד, שיעול וכד')",
    ALERGY_PLACEHOLDER4: 'מהן ההנחיות לטיפול בזמן התקף',
    ALERGY_DOC:
        'במצב זה, הנך נדרש להמציא הצהרת רופא בנוגע לאלרגיה/רגישות לנוחיותך, מצ״ב פורמט',
    DOWNLOAD: 'לחץ כאן להורדה',
    LETHAL: 'אלרגיה מסכנת חיים',
    DIFICULTY: 'לבני/בתי יש לקות בתחומים הבאים',
    DIFFICLTY_ARR_L: [
        'תקשורתית',
        'פיזית',
        'קוגניטיבית',
        'חושית',
        'רגשי/התנהגותי',
    ],
    DIFICULTY_PLACEHOLDER: 'סוג הקושי',
    MEDICAL_EQUIUPMENT: 'בני/בתי נעזר/ת בציוד רפואי כגון משאף או ערכת זריקות',
    MEDICAL_EQUIUPMENT_PLACEHOLDER: 'פירוט הציוד הרפואי',
    MEDICAL_SELF: 'השימוש נעשה באופן עצמאי',
    DRUGS: 'בני/בתי מקבל/ת טיפול תרופתי.',
    DRUGS_PLACEHOLDR: 'פירוט סוגי תרופה ואופן הטיפול בה',
    EPILEPSY: 'בני/בתי סובל מאפילפסיה.',
    EPILEPSY_1: 'מתי קיבל את ההתקף הראשון?',
    EPILEPSY_2: 'מתי קיבל התקף לאחרונה?',
    EPILEPSY_3: 'איזה תרופות צורך?',
    EPILEPSY_4: 'מתי ביקר לאחרונה אצל ניורולוג?',
    EPILEPSY_5: 'סדר פעולות מומלץ בהתקף',
    EPILEPSY_6: 'גורמים מעוררי התקף',
    EPILEPSY_7: 'תדירות התקפים',
    EPILEPSY_7_ARR: [
        'פעם בשנה ויותר',
        'פעם בחצי שנה',
        'פעם בשלושה חודשים',
        'פעם בחודש',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        'שבועי',
        'יומי-מספר התקפים ביום',
    ],
    EPILEPSY_8: 'איך נראה התקף?',
    EPILEPSY_9: 'סימנים מקדימים להתקף',
    EPILEPSY_10: 'תרופת חירום',
    EPILEPSY_11: 'דרך נטילת התרופה',
    EPILEPSY_12: 'טווח זמן עד נטילת התרופה',
    EPILEPSY_LAST_P: '*שימו לב',
    EPILEPSY_LAST_P_2:
        '\'כנפיים של קרמבו\' תפעל על פי הנחיות ההורה באופן מידי בעת ההתקף, אולם אם ההתקף נמשך מעל 5 דקות, או חוזר על עצמו - יוזעק אמבולנס לסניף, זאת בהתאם להוראות חוזר מנכ"ל משרד החינוך, תשס"ב/2(א), י"ד תשרי תשס"ב, 1 באוקטובר 2001.לאור האמור לעיל, אנו מבקשים אישורכם לפעילות בנכם / בתכם כדלקמן :',
    EPILEPSY_LAST_CHECK:
        'הנני מאשר בזאת כי אין מניעה שבני/בתי ישתתף/תשתתף בפעילות בתנועה למרות הופעת התקפי האפילפסיה.ידוע לי כי במידה ויהיה שינוי בתדירות ובעוצמת ההתקפים של בני / ביתי , או ביכולת הצוות בסניף להתמודד, ייתכן ויהיה צורך בנוכחותי או מבוגר מטעם המשפחה בזמן הפעילות.בחתימתי אני גם מאשר את הנחייתי שלעיל להתנהלות בעת התקף אפילפסיה של בני / בתי.        ',
    PARENTS_APPROVAL_H1: 'אישור הורים ',
    PARENTS_APPROVAL1: 'הנני מאשר/ת לבני/בתי להשתתף בפעילות "כנפיים של קרמבו”.',
    PARENTS_APPROVAL1_P_STRONG: 'לידיעתכם,',
    PARENTS_APPROVAL1_P:
        '"כנפיים של קרמבו" מבטחת את פעיליה בביטוח צד ג\', לתשומת ליבכם הביטוח מכסה אך ורק פגיעה הנגרמת במהלך הפעילות בתנועה ועקב פעילות זו.',
    PARENTS_APPROVAL2:
        '  ידוע לי כי אין באפשרות התנועה לספק את התנאים הדרושים על מנת למנוע חשיפה לאלרגנים/ גורמים מעוררי אפילפסיה ולכל גורם נוסף העלול להוביל ליצירת התקף כלשהו.        ',
    PARENTS_APPROVAL3:
        'מחובתי לצייד את בני/בתי בכל הנדרש למתן טיפול רפואי בגין מצב רפואי ידוע.',
    EXPOSURE_H1: 'אישור חשיפה    ',
    EXPOSURE_APPROVAL1_ARR: [
        'לא מאשר כלל',
        'מאשר בתיאום מראש בלבד    ',
        'מאשר',
        'מאשר למטרות מסויימות בלבד',
    ],
    EXPOSURE_APPROVAL1_ARR_SPECIAL: 'מאשר למטרות מסויימות בלבד',
    error_msg: 'שדה חובה',
    EXPOSURE_APPROVAL4_ARR: [
        'שימוש פנימי (במסגרת תצוגה בסניף בלבד - לוח תמונות, מצגות וסרטונים).',
        'מצגות - הכשרות, סמינרים, גיוסים.',
        "רשתות חברתיות (פייסבוק/אינסטגרם/סנפצ'אט). ",
        'לכל מטרה במסגרת חשיפת הפעילות של התנועה בציבור        ',
        'תוכן שיווקי - קמפיינים פרסומיים של התנועה (ארצי/עירוני). ',
        'תקשורת - ארצית/מקומית - עיתונות כתובה/טלוויזיה.',
    ],
    EXPOSURE_APPROVAL5:
        'ידוע לי כי פרטי בני/בתי מועברים לעיתים לרשות מקומית/משרדי ממשלה/חברות ביטוח לצרכי תמיכה וביטוח.    ',
    RIDE_PERMISSION_H1: 'אישור ליווי נסיעה    ',
    RIDE_P: "כחלק מנגישותה של התנועה, 'כנפיים של קרמבו' מעמידה מערך היסעים לפעילות השבועית וממנה, שמאפשר לפעילים שאינם עצמאיים וזקוקים לתיווך אישי,להשתתף בפעילות באופן קבוע. את מערך ההיסעים מלווים בני נוער עצמאיים בגילאי 16-18 הפעילים בסניף. מערכי ההיסעים והכשרת מלווי ההסעות מוחזקים ומועברים בסניפים בהנחיית מחלקת בטיחות ומפעלים של התנועה.",
    RIDE_PERMISSION_OPTIONS: [
        'הגעה עצמאית ',
        'מגיעים לאסוף אותו',
        '(משתנה (לפעמים כך ולפעמים כך',
    ],
    RIDE_PERMISSION1:
        'ידוע לי כי בני/בתי עשויים לקחת חלק במערך ההיסעים כמלווים של פעילי התנועה הזקוקים להסעה, ליווי הכרוך בנסיעה ברכב ההסעות.',
    RIDE_PERMISSION2:
        'הנני מאשר/ת לבני/בתי להצטרף למערך ההיסעים, אשר הליווי בו מתבצע על ידי בני ובנות נוער הפעילים בסניף.',
    RIDE_OPTIONS: ["א'", "ב'", "ג'", "ד'", "ה'", "ו'", "ז'"],
    NEXT: 'המשך לפרטי הורים',
    ERROR_MSG: 'שדה חובה',
    UPLOAD_TEXT:
        'במצב זה, הנך נדרש להמציא הצהרת רופא בנוגע לאלרגיה/רגישות לנוחיותך, מצ״ב פורמט',
    UPLOAD_DOWNLOAD: 'לחץ כאן להורדה',
};
exports.PERSONAL = {
    H1: 'ברוכים הבאים לתנועת “כנפיים של קרמבו”.',
    H2: 'הרשמה אישור הורים, הצהרת בריאות ותשלום בכרטיס אשראי, לשנת הפעילות 2019/20.',
    H3: 'להסבר לגבי דמי ההרשמה והפעילות השנתית יש ללחוץ',
    H3_2: 'להסבר לגבי ביטול ההרשמה יש ללחוץ ',
    INFO: 'פרטים אישיים',
    HERE: 'כאן',
    GENDER: 'מין',
    GENDER_ARR: ['זכר', 'נקבה', 'אחר'],
    MALE: 'זכר',
    FEMALE: '',
    MONTH: 'חודש',
    MONTHS_ARR: [
        'ינואר',
        'פברואר',
        'מרץ',
        'אפריל',
        'מאי',
        'יוני',
        'יולי',
        'אוגוסט',
        'ספטמבר',
        'אוקטובר',
        'נובמבר',
        'דצמבר',
    ],
    DAY: 'יום',
    YEAR: 'שנה',
    NAME: 'שם פרטי',
    LAST_NAME: 'שם משפחה',
    SCHOOL: 'שם בית ספר',
    ZIP: 'מיקוד',
    FAMILY: 'שם משפחה',
    SHIHVA: 'שכבה',
    SHIHVA_ARR: [
        "א'",
        "ב'",
        "ג'",
        "ד'",
        "ה'",
        "ו'",
        "ז'",
        "ח'",
        "ט'",
        "י'",
        "יא'",
        "יב'",
    ],
    GRADE: 'כיתה',
    GRADE_ARR: [1, 2, 3, 4, 5, 6],
    BRANCH: 'סניף',
    ID: 'מס’ תעודת זהות',
    VETEK: 'וותק חניך',
    VETEK_ARR: ['פעיל חדש (שנה ראשונה)', 'פעיל ותיק'],
    PHONE: 'מספר טלפון פעיל',
    EMAIL: 'דוא”ל',
    POSITION: 'תפקיד',
    POSITION_ARR: [
        'חונך (פעיל בשכבה ח-יב)',
        "חניך (קב' חונכויות)",
        'פעיל שכבת ז',
        "פעיל שכבה צעירה ד'-ו",
        'חבר צוות מוביל',
        'חבר צוות מנהל',
    ],
    POSITION_RES: 'תחום אחריות',
    LEAD_TEAM_ARR: [
        'מרכז סניף',
        'רכז חונכויות ',
        'רכז שכב"ג',
        'רכז מפעלים',
        'רכז שכב״צ ד-ו',
        'רכב שכב״צ ז-ח',
    ],
    MANAGEMENT_TEAM_ARR: [
        'מדריך',
        'משלב',
        'רכז תקשורת',
        'צוות מפעלים',
        'צוות תקשורת',
    ],
    HMO: 'קופת חולים',
    HMO_ARR: ['כללית', 'מכבי', 'מאוחדת', 'לאומי', 'אין'],
    ADDRESS: 'רחוב ומספר בית',
    FOOD: 'תזונה',
    FOOD_ARR: ['רגיל', 'צמחוני', 'טבעוני', 'רגישות לגלוטן'],
    CITY: 'עיר',
    EXTRA_SHIRT: 'מעוניין בחולצה נוספת?',
    EXTRA_SHIRT_ARR: ['לא', 'כן'],
    SHIRT_SIZE: 'בחר מידת חולצה',
    SHIRT_ARR: [
        '10',
        '12',
        '14',
        '16',
        'S',
        'M',
        'L',
        'XL',
        'XXL',
        'XXXL',
        'XL4',
    ],
    SHIRT_ARR_NO_OPTION: [
        '10',
        '12',
        '14',
        '16',
        'S',
        'M',
        'L',
        'XL',
        'XXL',
        'XXXL',
        'XL4',
        '',
    ],
    EXTRA: 'תוספות',
    SPECIAL_NEEDS: 'בעל צרכים מיוחדים',
    SPECIAL_NEEDS_ARR: ['לא', 'כן'],
    MOBILITY: 'ניידות',
    MOBILITY_ARR: [
        'עצמאי',
        'הליכון',
        'כסא גלגלים',
        'כסא גלגלים ממונע',
        'כסא גלגלים אך יכול ללכת עם עזרה',
        'קושי מוטורי קל',
    ],
    MOBILITY_REWARD: 'בני/בתי זכאי/ת לגמלת ניידות מהמוסד לביטוח לאומי',
    MOBILITY_REWARD_ARR: ['לא', 'כן'],
    YES: 'כן',
    NO: 'לא',
    DISABLITY_REWARD: 'בני/בתי זכאי/ת לגמלת ילד נכה מהמוסד לביטוח לאומי',
    DISABLITY_REWARD_ARR: ['לא', 'כן'],
    NEXT: 'המשך',
    PERCENT: 'אחוז גמלה',
    BIRTH: 'תאריך לידה',
    ADD: 'הוסף אח/ות',
    EXTRA_BROTHER: 'אח/ות נוסף/ת',
    REMOVE_BROTHER: 'הסר אח/ות',
    ERROR_MSG: 'שדה חובה',
    VALIDATION_ERROR: 'תעודת זהות אינה תקינה',
    VALIDATION_ERROR_PHONE: 'מספר טלפון לא תקין',
    VALIDATION_ERROR_ZIP: 'מיקוד לא תקין',
    VALIDATION_ERROR_EMAIL: 'כתובת דוא"ל לא תקינה',
    YEARS_ARR,
    DAYS_ARR,
    GRADES_ARR: [
        'א',
        'ב',
        'ג',
        'ד',
        'ה',
        'ו',
        'ז',
        'ח',
        'ט',
        'י',
        'י״א',
        'י״ב',
    ],
};
exports.about = {
    values_h1: 'About Krembo Wings',
    value1_h3: 'Leading a Social Change',
    value1_p:
        'Krembo Wings is a youth movement for children and youth with and without disabilities. Yes, we are a youth movement in every sense of the word, and members of the movement do not view their activity as “volunteer work”, but as an experiential social activity – for themselves and for others.',
    value2_h3: 'Conducting Socio-Educational Activities',
    value2_p:
        'Our members convene weekly informal social-educational activities in the evenings, based on the model of personal counseling in a group environment. Most of our counselors are youth who study in mainstream schools. The joint activities promote awareness of populations with disabilities and of social inclusion. ',
    value3_h3: 'Creating a Meaningful Place for Everyone',
    value3_p:
        'We believe that all children, regardless of their capabilities, ethnicity, religion, or gender share a common need – they all want and need to experience social belonging, and every child deserves joyful time spent with friends.',
    value4_h3: 'Commitment to Full Accessibility',
    value4_p:
        'We are committed to providing a fully accessible venue for our activities. We provide accessible transportation for members from their homes to the venue and back in vehicles geared for people with disabilities, supervised and accompanied by a Krembo Wings member. We provide nursing services by trained nursing professionals who assist members with their intimate needs during our activities.',
    started_h2: 'How It All Started',
    started_section1_h3: 'בבית משפחת קובי, נולדה "רוח קרמבו"',
    started_section1_p:
        'Krembo Wings is a Youth Movement leading to social change, unique in the world, for children with and without disabilities. There are thousands of activists in the Movement – children, youth, youngsters in their ‘Year of Service’ and students. All of them consider Krembo Wings to be their Movement, and do not look upon themselves as being volunteers.',
    started_section2_h3: 'מ"רוח קרמבו" ל"כנפיים של קרמבו"',
    started_section2_p:
        'Krembo Wings organizes weekly afternoon social–educational activities in a non-formal framework and the model we use is personal mentoring in a group framework. Most of our counsellors are youth who come from the general school system. This joint activity - between children with and without disabilities – greatly contributes to the overall awareness and social inclusion of those children with disabilities.',
    started_section3_h3: 'משק הכנפיים הגיע לכל רחבי הארץ',
    started_section3_p:
        'It provides them with their specific social needs and allows their better integration into Israeli society. Krembo Wings accepts members with all types of special needs – physical disability, cognitive difficulty, communication problems, and provides each with a tailor made solution to their social needs. It also helps to develop their social skills and involvement with society around them.',
    started_section3_p_2:
        'The weekly activities cover all subjects of interest to both Israeli society and the world in general and in addition the Movement’s branches are involved in local community activity.',
    started_section4_p:
        'Krembo Wings is committed to making its activities accessible to all by providing a location with easy access, arranging special transport from home and where necessary in wheelchair accessible vehicles. Each journey is supervised and accompanied by one of our counsellors. At each meeting, and in every branch, there is a professional care worker who assists the members with their intimate needs during the activity. If required we have special communication appliances, use sign language, and make it economically feasible for all to join by charging a nominal registration fee.',
    structure_h1: 'Movement structure',
    milestones_h1: 'Landmarks',
    active: 'members',
    branches: 'branches',
    opened_this_year: 'סניפים שנפתחו בשנה זו',
    managers_h1: 'Management',
    contact: 'Contact ',
    vaad: 'Board of Directors',
    vision_h1: 'Krembo Wings’ Vision',
    vision_h2: 'Creating a meaningful place for everyone, together',
    vision_section1_h3:
        'This vision reflects the movement’s spirit and ethical code',
    vision_section1_p:
        'Creating a meaningful place for everyone, together. This vision reflects the movement’s spirit and ethical code:',
    vision_section2_h3:
        'Creating together a significant, beneficial, and empowering place for each and every member, with or without disabilities, regardless of social and cultural background.',
    vision_section2_p:
        'Krembo Wings members are the future generation who will shape Israeli society and pass on the values of social equality, demonstrating care for the wellbeing of all Israeli populations and communities.',
    vision_last_h4:
        'The movement’s mission is to establish a Krembo Wings branch in each and every community in Israel, so as to provide equal opportunities, social life, and a sense of belonging for each and every child with special needs – regardless of their cultural background, socio-economic status, religion, or gender. The movement also works to change perceptions of and attitudes towards people with disabilities in Israeli society.',
    last_h1: 'Letter from the CEO',
    last_p1:
        'Krembo Wings has generated a small, quiet, yet powerful and significant, revolution in Israeli society ever since its establishment in 2002. Thousands of children and youth, with and without disabilities, are active members in branches throughout Israel, demonstrating that the values of inclusion, integration, and social equality are not mere slogans – but represent real social activism that contributes and empowers all those who actively promote them.',
    last_p2:
        'Krembo Wings provides children with disabilities with the social activity they lack in their day-to-day life, and integrates them into our society, so that they can develop their social skills. Together with youth from the mainstream education system from all social and socio-economic backgrounds, Krembo Wings members become social entrepreneurs who contribute to their communities, opening branches that integrate children and youth with and without disabilities – and making a significant positive change in Israeli society.',
    last_p3:
        'Krembo Wings provides meaningful activities for its members and a sense of social belonging, while assisting children who are forming their personal identity. Our special-needs members and counselors are ambassadors of good will who spread the movements’ values to all social circles – their families, friends, and communities – becoming exemplary models of acceptance and inclusion of the other.',
    last_p4:
        'At its core, Krembo Wings is a youth movement that includes all the classic ingredients of informal education, social involvement, mutual decision-making, autonomy, collaborative youth initiatives, culture, ideology, symbols, uniforms, and more.',
    last_p5:
        'We believe that Krembo Wings has proven that it is worthy of being recognized as an official youth movement, and that it promotes the right of all children with diverse disabilities to belong to peer groups, by adapting the movement’s activities and making them fully accessible so all members can participate. ',
    last_p6:
        'Unfortunately, Krembo Wings is not yet recognized by the Ministry of Education, and does not receive budgeting like other youth movements. We are working to change this situation and to receive official recognition and budgeting – as a right and not as a donation.',
    last_p7:
        'Krembo Wings is a unique, innovative Israeli initiative, and its representatives were invited to represent Israel in the UN Convention in November 2015, in recognition of our unique model, which offers a solution to valuable and effective integration of children and youth with and without disabilities, in Israel and abroad.',
    last_p8:
        'I invite you to come and visit our branches, to get acquainted with our activities, and to take part in this significant achievement. We invite you to share our vision: “Together creating a meaningful place for everyone” and to help us achieve our immediate goal – to establish a branch in each and every community in Israel.',
    last_p9: 'Yours truly,',
    last_p10: 'Talia Bejerano, CEO',
    structureBtn: 'Watch movement structure here',
    isHebrew: false,
};
exports.signup = {
    header_h1: 'Member registration',
    header_text_1:
        'Krembo Wings invites you to register for our rich and varied yearly activities program, intended for counselors and members with disabilities, alike. Yearly participation fees are symbolic, and subsidized when needed. New members must purchase uniforms. Returning members can purchase an additional uniform shirt for 50 NIS.',
    header_text_2:
        'Members and counselors pay the same fees, since they are equal participants.',
    header_small:
        '* Please note: Please contact the branch prior to new member registration to confirm that there is place available. At that time, the branch coordinator will schedule a getting-to-know you house visit during which any required adjustments for the child during weekly activities will be discussed.',
    header_btn: 'Member registration',
    docs_h1: 'Documents',
    doc1_text: 'Opening year letter for our members and their parents',
    doc2_text: 'Cancelation policy',
    doc3_text: 'Cancelation of yearly registration fees',
    doc4_text: 'Day seminar / training course cancelation form',
    doc5_text: 'Spring activities 2019',
    doc6_text: 'Cancellation and refund form for spring activities 2019',
    doc8_text: 'טופס ביטול הרשמה למחנה קיץ',
    doc7_text: 'חוזר למחנה קיץ 2019',
    view: 'view',
    adopt_h2:
        'If you would like to adopt a member from a disadvantaged family and assist in the payment of their registration fees – your donation is welcome!',
    adopt_btn: 'Adopt a member',
};
exports.footer = {
    donate: ' Make a Donation',
    contact: 'Contact Us',
    knowladge: 'Knowledge Center',
    knowladge_1: 'Krembo Wings’ Vision and Values',
    knowladge_2: 'Ceremonies and Symbols',
    knowladge_3: 'Membership',
    knowladge_4: 'Our Educational Outlook',
    press: 'Press',
    press_1: 'Krembo Wings’ Projects ',
    press_2: 'Donation Events',
    press_3: 'Press',
    press_4: 'Krembo Magazine',
    about: 'About us',
    about_1: 'Our Values',
    about_2: 'How It All Started',
    about_3: 'Movement Structure',
    about_4: 'Landmarks',
    about_5: 'Management',
    about_6: 'Board of Directors',
    about_7: ' Krembo Wings’ Vision ',
    about_8: 'Letter from the CEO',
    last_section_1: 'Krembo Wings',
    last_section_2: '(RA) 58045568',
    last_section_3: 'address',
    last_section_4: ' 17 HaNeviim St., Ramat HaSharon 4727919',
    last_section_5: 'PO Box',
    last_section_6: '1166',
    last_section_7: 'Email:',
    last_section_8: 'krembo@krembo.org.il',
    last_section_9: 'For queries and donations visit "Contact Us"',
    last_section_10: 'available 24/7 at',
    last_section_11: 'office',
    last_section_12: '09-8852385',
    last_section_13: '8849*',
};
exports.contact = {
    form_h1: 'Contact',
    name: 'Name',
    phone: 'Phone number',
    email: 'Email address',
    subject_select: 'Subject',
    subject_1: 'Donations',
    subject_2: 'Member registration',
    subject_3: 'Wanted',
    subject_4: 'General',
    messgae: 'Message',
    send: 'Contact',
    managers_h1: 'Management',
    name_fill: 'Enter full name',
    phone_fill: 'Enter phone number',
    email_fill: 'Enter email address',
    subject_fill: 'Choose subject',
    bad_phone: 'Invalid phone number',
    bad_email: 'Invalid email',
    send_succeded: 'Received',
};
exports.educational = {
    h1: 'Our Educational Outlook',
    h2: 'We aspire to connect and share',
    h3: 'Krembo Wings is a youth movement that connects and brings together children and youth with and without disabilities through joint social activities. We believe that creating a framework for joint meetings can lead to mutual understanding, create opportunities for social connections, and make a change in perceptions of and attitudes towards people with disabilities.',
    section1_h3:
        'Our educational approach empowers counselors as well as members with disabilities',
    section1_p:
        'Assimilation of concepts such as independence, capability, and leadership in their broader sense, and the focus on a positive attitude, empowers both counselors and members alike. In a competitive society, Krembo Wings’ educational approach can lead all youth to develop a sense of freedom and self-assurance that promotes responsibility and leadership.',
    section2_h3: 'The origin of our educational approach',
    section2_p:
        'The educational approach that Krembo Wings’ activities are based on was developed and formed by Claudia Koby, the co-founding mother of the movement.',
    section2_p2:
        'Claudia’s most significant source of inspiration was her son, Kfir, whom she calls “my most important teacher and leader.” Kfir, who passed away at a young age, had multiple complex disabilities: he could not talk or walk – but he could communicate with his surroundings, and was determined to become a participant in his family’s life, to experience a sense of belonging, and to take part in the activities around him.',
    section3_h3: 'Human dignity – regardless of limitations and disabilities',
    section3_p:
        'We believe that we should treat each and every person equally, without making assumptions from apparent disabilities. We should first refer to each person according to their age, and later adapt our discourse and communication according to their needs and abilities.',
    section4_h3: 'The components of our educational approach',
    section4_p:
        'At the basis of our educational approach are three components: independence, ability, and leadership. We do not interpret these concepts according to their literal definitions, but rather use them to modify the definitions accepted by our society.',
    flex_section1_h3: 'Leadership',
    flex_section1_p:
        'We believe that each and every one of us can be a leader, and that even a person’s needs can become a leading motivation for action. A person who expresses their needs and leads other people to fulfill his or her desires or ideas is a leader, even if they require assistance to accomplish such a mission.',
    flex_section2_h3: 'Ability',
    flex_section2_p:
        'We believe that it is important to appreciate, praise, and compliment a person’s achievements according to their abilities – to emphasize capabilities and not disabilities. Appreciating abilities, even minor ones, can lead our society to a more respectful and inclusive approach, where people receive appreciation even if they have disabilities. We believe that positive reinforcement and emphasis on capabilities can lead people to a stronger belief in themselves and to further successes. ',
    flex_section3_h3: 'Independence',
    flex_section3_p:
        'Independence can be expressed in the way we think, our free will, our choices, and in our actions, no matter how big or how small. We encourage counselors to help members with disabilities to identify the places where they can take part in our activities actively and independently. It is our job to allow and encourage each and every member to take part in activities by identifying their strengths and emphasizing them.',
    small_bottom:
        'Kfir’s parents understood that it was their job, duty, and right to make the necessary adjustments for him, and to offer him support that would allow him to realize these values.',
    big_bottom:
        'This lead to Claudia’s insightful conclusion that a child with (and without) disabilities is the sum of many variables: their desires, abilities, preferences, environment, and opportunities – and their life should not be realized just according to their disabilities.',
};
exports.activity = {
    h1: 'Krembo Wings Activities',
    h2: '’Krembo Wings’ activities are unique because they are adapted to children and youth with disabilities.',
    h3: 'We believe that by adapting our activities and supporting our members with disabilities we can create social activities that suit everyone – getting to know, and learning to accept each other. Krembo Wings activities deal with values related to Israeli society, with an emphasis on changing perceptions of and attitudes towards people with disabilities.',
    first_section_part1_h3: 'Counselors',
    first_section_part1_p:
        'Counselors are youth who belong to all parts of the mainstream educational system.',
    first_section_part2_h3: 'Members with disabilities',
    first_section_part2_p:
        'are children and youth with disabilities – either physical, cognitive, sensorial, communicational, or others.',
    second_section_h3:
        'During our activities, counselors support all members, providing help according to their physical, cognitive, and communicational needs.',
    second_section_p:
        'Comprehensive acquaintance with members with disabilities and counselor support Getting-to-know-you meetings',
    flex_part1_h3: 'Intuition',
    flex_part1_p:
        'We encourage counselors to create personal relationships and to come up with creative solutions during our activities. From our experience, a new connection with a youth that has a slight touch of innocence to it and is based on a positive approach, may stimulate new opportunities for members with disabilities. ',
    flex_part1_h5:
        'Intuitive connection encourages new opportunities for the special member.',
    flex_part2_h3: 'Training',
    flex_part2_p:
        'All staff partake in training programs, which prepare them for their work with special-needs members. The training programs answer counselors’ questions and deliberations related to their interaction with all members. We accept and understand counselors’ feelings, Even if and when they experience a sense of deterrence, rejection, or discouragement when they meet a member with disabilities. We encourage them to understand that such feelings are acceptable.',
    flex_part2_h5:
        'Discussing difficult issues leads to understanding and accepting the other.',
    flex_part3_h3: 'Getting-to-know-you meetings',
    flex_part3_p:
        'We invest a great deal of energy into getting to know our members and their families, starting with initial house visits. These visits allow counselors to get to know the member’s natural surroundings, and to receive vital information and insights about him or her, and about their unique needs. The familiarization meeting is the first of many opportunities that the child, their family, and Krembo Wings counselors will bond.',
    flex_part3_h5:
        'The visits allow the counselor to get to know both the member and his/her family.',
    attitude_h3:
        'The “counselor as intermediary” attitude – a unique counseling model',
    attitude_p1:
        'The purpose of the supportive relationship between counselors and special-needs members is to enable the latter to take part in the activities – not to “do things for them.”',
    attitude_p2:
        'Counselors provide the minimal support needed to allow the special-needs member to take part in the activity.',
    attitude_p3:
        'They are the special-needs members’ partners during the activities, and they experience the activities together.',
    attitude_p4:
        'Counselors need to be able to recognize when to take a step back ',
    attitude_p5:
        'because moments when members with disabilities succeed in participating without any help or with minimal support are very meaningful for everyone.',
    attitude_gray:
        'This “intermediary” approach is expressed in the following ways:',
    last_flex1_h3: 'Encouraging independence',
    last_flex1_p:
        'We encourage counselors to provide members with disabilities with opportunities for independent experiences, and therefore they should always look for the best way to lead members to becoming active, independent participants in the activities, as much as possible. In addition, we promote the concept of “moderated support” – in order to allow members to be independent participants. For example, an arts and crafts outcome does not have to be perfect, but rather a result of a collaborative work between the counselor and the member – which is better than a perfect one resulting from the counselor doing all the work by themselves while the member with disabilities just watches.',
    last_flex2_h3: 'Understanding and listening',
    last_flex2_p:
        'Understanding and listening are significant aspects of the counseling process. It is important to understand and become familiar with the member’s disabilities and abilities, the reasons for their particular behavioral patterns, potential challenging situations, and immediate needs and desires during activities.',
    last_flex3_h3: 'Respect to all humans',
    last_flex3_p:
        'Each member comes from a different background, each with their own unique abilities and disabilities, likings and desires. Each member is exposed to a different world of experiences and opportunities. All these features form their personality and affect their knowledge and abilities. Consequently, when we talk to members with disabilities, we find great differences between them, despite the fact that they belong to the same reference group. Therefore, we should approach each and every member in a natural, ordinary, and respectful manner. After getting to know them more deeply, we can identify their level of understanding and be able to adapt ourselves accordingly.',
    last_flex4_h3: 'Positive attitude',
    last_flex4_p:
        'We should observe each situation with the intention to enable each member to experience success, by locating and reinforcing their capabilities – not their challenges. ',
    last_flex5_h3: 'Accessibility and adaptability',
    last_flex5_p:
        'Counselors should adapt, adjust, and convey activities personally to each member with disabilities. They should adjust the way they communicate with the member, adapt arts and crafts activities to the member’s special needs, and support their group motoric activities.',
};
exports.vision = {
    h1: '’Krembo Wings’ Vision Statement',
    create_h2: 'Creating a Meaningful Place for Everyone',
    create1_h3: 'This vision reflects the movement’s spirit and ethical code:',
    create1_p:
        'Creating together a significant, beneficial, and empowering place for each and every member, with or without disabilities,',
    create2_h3: 'regardless of social and cultural background.',
    create2_p:
        'Krembo Wings members are the future generation who will shape Israeli society and pass on the values of social equality, demonstrating care for the wellbeing of all Israeli populations and communities.',
    create3_h3:
        'The movement’s mission is to establish a Krembo Wings branch in each and every community in Israel,',
    create3_p:
        'so as to provide equal opportunities, social life, and a sense of belonging for each and every child with special needs – regardless of their cultural background, socio-economic status, religion, or gender. The movement also works to change perceptions of and attitudes towards people with disabilities in Israeli society.',
    circle1_h3: 'I Am a Friend – Mutual Commitment ',
    circle1_p:
        'To take care of one another. To accept the fact that no one is perfect. To respect one another and each person’s capabilities. To help, support, accept, and interact.',
    circle2_h3: 'I Love – “Love your fellow as yourself”',
    circle2_p:
        'To love by understanding and with the ability to accept any situation, even when it is hard. To always look on the positive side of things and to act out of joy.',
    circle3_h3: 'I Am Israeli',
    circle3_p:
        'Krembo Wings was founded in Israel, based on the Israeli values of mutual responsibility and helping the other. Krembo Wings members come from all backgrounds of Israeli society. We lead Israeli society towards a change in its perceptions of and attitudes towards people with disabilities.',
    circle4_h3: 'I Belong – Belonging, Inclusion, Mutuality',
    circle4_p:
        'Each and every one of us works to fulfill their potential and is a collaborative participant in our activities. It is our mission to support and enable everyone to fulfill their potential. We should learn how to help others and how to receive help',
    circle5_h3: 'I Can – Abilities and Independence',
    circle5_p:
        'I believe in myself, in my ability to influence others and to lead change, and in my choice to be independent',
    circle6_h3: 'I’m a Leader – Commitment, Responsibility, and Leadership',
    circle6_p:
        'Each and every one of us is a leader. Every one of us can bring about change, and together all of us can lead a social change',
};
exports.symbol = {
    h1: 'Ceremonies and Symbols',
    h2: 'Our Vision Badge',
    symbol_flex1_h3: 'The Israeli Flag',
    symbol_flex1_p:
        'The State of Israel is the place where Krembo Wings began, representing Israeli values of mutual responsibility and helping others',
    symbol_flex2_h3: 'The Lion Cub (Kfir)',
    symbol_flex2_p:
        'The lion cub (Hebrew: kfir) represents Kfir Koby, the first member of Krembo Wings and the movement’s inspiration. Our Vision Badge is awarded during the branch’s Order of the Wings, after learning of the movement’s philosophies including activities about the movement’s values',
    symbol_flex3_h3: 'The Wings',
    symbol_flex3_p:
        'It is our goal to spread our wings and bring the message of social change to all parts of Israeli society and throughout the world, today and in the future',
    symbol_bottom1_h3: 'Our Uniforms',
    symbol_bottom1_p:
        'Krembo Wings’ uniforms represent the movement’s leading values, and are important for creating a sense of unity and equality. Krembo Wings members and counselors arrive to the weekly activities wearing the movement’s uniforms – a blue shirt with a brown tie – the colors of our logo. The Krembo Wings logo is printed on the shirt’s front and back. The uniforms’ design can be adapted to our members’ needs, by using hidden buttons, loops for the tie, and sleeves with an adjustable length. The Krembo Wings tie is in a single color, representing the value of equality: we, all members and counselors, are all equal; each one of us is part of the whole.',
    symbol_bottom1_p2:
        'The Krembo Wings tie is given at a special branch ceremony shortly after the start of the year. In the ceremony, members and counselors sign our vision statement – “Together creating a meaningful place for everyone.”',
    symbol_bottom2_h3: 'Krembo Wings Salute',
    symbol_bottom2_p:
        'The Krembo Wings Salute, like all of our other symbols, was chosen bearing in mind all our members, their abilities, and disabilities.',
    symbol_bottom2_p2:
        'The salute enacts the movement’s logo – a winged krembo (an Israeli chocolate treat). Each of the six fingers represents one of the movement’s values. The salute is used in Krembo Wings ceremonies, such as the granting of our Vision Badge or the movement’s ties, or when singing the national anthem, HaTikva.',
};
let dropDown7 = [];
Object.keys(branch_parser_1.branchprices).map(function (key, index) {
    dropDown7.push(key);
});
exports.register = {
    form12Text: [
        'בני/בתי זכאי/ת לגמלת ניידות מהמוסד לביטוח לאומי',
        'בני/בתי זכאי/ת לגמלת ילד נכה מהמוסד לביטוח לאומי',
    ],
    //header
    heading: 'ברוכים הבאים לתנועת “כנפיים של קרמבו”.',
    subheader1:
        'אנו מזמינים אתכם להירשם לפעילות שנתית, עשירה ומגוונת, לחונכים וחניכים כאחד. ',
    subheader2: 'להסבר לגבי דמי ההרשמה והפעילות השנתית יש ללחוץ',
    subheader2Link: 'כאן.',
    subheader3: 'להסבר לגבי ביטול ההרשמה יש ללחוץ',
    subheader3Link: 'כאן.',
    paragraph:
        '*העלות השנתית לפעיל בתנועה הינה סמלית, כאשר כל פעיל חדש מחויב ברכישת חולצת מדים (פעיל ותיק יכול לרכוש חולצה נוספת בעלות של ₪50). התשלום נגבה באופן זהה מכל הפעילים בתנועה, חונכים וחניכים כאחד, מתוך תפיסה שכולם פעילים בתנועת הנוער כנפיים של קרמבו באופן שוויוני וזהה לחלוטין.',
    //
    //nav
    stage1: 'פרטי  חניך',
    stage2: 'אישור הורים',
    stage3: 'סיכום תשלום',
    //
    //forms headers
    firstHeader: 'פרטי חניך',
    secHeader: 'פרטים אישיים',
    //
    //labels
    gender: 'מין',
    dateOfBirth: 'תאריך לידה',
    //
    //placeholders
    form1Placeholders: ['מין', 'חודש', 'יום', 'שנה'],
    form11Placeholders: ['מעוניין בחולצה נוספת?', 'בחר מידת חולצה'],
    form2placeholders: [
        'שם מלא',
        'שם בית ספר',
        'מיקוד',
        'שם משפחה',
        'שכבה',
        'סניף',
        'מס’ תעודת זהות',
        'דוא”ל',
        'ניידות',
        'מספר טלפון',
        'עיר',
        'בעל צרכים מיוחדים',
        'וותק חניך',
        'רחוב ומספר בית',
        'אחוזי נכות',
        'תזונה',
        'קופת חולים',
        'כיתה',
    ],
    //
    tshirtSize: 'בחר מידת חולצה',
    dropDown1: [
        'עצמאי',
        'הליכון',
        'כסא גלגלים',
        'כסא גלגלים ממונע',
        'כסא גלגלים אך יכול ללכת עם עזרה',
        'קושי מוטורי קל',
    ],
    dropDown2: ['חניך חדש(שנה ראשונה)', 'חניך ותיק'],
    dropDown3: ['כן', 'לא'],
    dropDown4: [
        '10',
        '12',
        '14',
        '16',
        'S',
        'M',
        'L',
        'XL',
        'XXL',
        'XXXL',
        'XL4',
    ],
    dropDown5: ['זכר', 'נקבה', 'אחר'],
    dropDown6: ["א'", "ב'", "ג'", "ד'", "ה'", "ו'", "ז'", "ח'", "ט'"],
    dropDown7,
    dropDown8: ['כן', 'לא'],
    dropDown13: ['רגיל', 'צמחוני', 'טבעוני', 'רגישות לגלוטן'],
    firstNameEmpty: 'אנא מלא שם פרטי',
    lastNameEmpty: 'אנא מלא שם משפחה',
    schoolNameEmpty: 'אנא מלא את שם בית הספר',
    streetEmpty: 'אנא מלא כתובת',
    cityEmpty: 'אנא מלא עיר',
    mobillityEmpty: 'אנא בחר מידת ניידות',
    vetekEmpty: 'אנא בחר ותק חניך',
    anotherTshirtEmpty: 'אנא בחר האם הינך מעוניין בחולצה נוספת',
    sizeTshirtEmpty: 'אנא בחר מידת חולצה',
    genderEmpty: 'אנא בחר מגדר',
    classEmpty: 'אנא בחר שכבה',
    classNumberEmpty: 'אנא מלא כיתה',
    branchEmpty: 'אנא בחר סניף',
    specialNeedsEmpty: 'אנא ציין האם החניך בעל צרכים מיוחדים',
    dietEmpty: 'אנא בחר תזונה',
    hmoEmpty: 'אנא בחר קופת חולים',
    monthEmpty: 'אנא הזן חודש',
    dayEmpty: 'אנא הזן יום',
    yearEmpty: 'אנא הזן שנה',
    dayInvalid: 'יום לא תקין',
    yearInvalid: 'שנה לא תקינה',
    emailEmpty: 'אנא מלא כתובת דואר אלקטרוני',
    emailInvalid: 'כתובת דוא"ל לא תקינה',
    idEmpty: 'אנא מלא תעודת זהות',
    idInvalid: 'תעודת זהות אינה תקינה',
    mikudEmpty: 'אנא מלא מיקוד',
    mikudInvalid: 'מיקוד לא תקין',
    phoneEmpty: 'אנא הזן מספר טלפון',
    phoneInvalid: 'מספר טלפון לא תקין',
    btnContinue: 'המשך',
    //form2
    parent1fullNameEmpty: 'אנא מלא שם מלא של הורה החניך',
    parent1placeOfBirthEmpty: 'אנא מלא תאריך לידה של הורה החניך',
    parent1phoneEmpty: 'אנא מלא טלפון ',
    parent1phoneInvalid: 'מספר טלפון לא תקין',
    parent1workPlaceEmpty: 'אנא מלא מקום עבודה',
    parent1emailEmpty: 'אנא הכנס כתובת דוא"ל',
    parent1emailInvalid: 'כתובת דוא"ל לא תקינה',
    declarationStatusEmpty: 'אנא מלא חלק זה',
    // declarationStatusText1: 'אני מצהיר כי לבני/בתי אין כל מגבלה בריאותית',
    // declarationStatusText2:'יש לבני/בתי מגבלות בריאותיות המונעות השתתפות חלקית בפעילות הנדרשת (כגון: אסטמה, סוכרת נעורים, וכדומה)',
    dropDown9: ['כן', 'לא', 'ללא אלרגיה'],
    disabillityDescriptionEmpty: 'אנא פרט מגבלות',
    kindOfAlergyEmpty: 'אנא פרט את סוג האלרגיה',
    alergyLethalEmpty: 'אנא בחר שדה',
    approvalText:
        '  ידוע לי כי אין באפשרות התנועה לספק את התנאים הדרושים על מנת למנוע חשיפה לאלרגנים/ גורמים מעוררי אפילפסיה ולכל גורם נוסף העלול להוביל ליצירת התקף כלשהו. מחובתי לצייד את בני/בתי בכל הנדרש למתן טיפול רפואי באם ידרש לכך.',
    approvalEmpty: 'אנא אשר הצהרה',
    aproveTermsEmpty: 'אנא אשר תקנון התנועה',
    typesOfDisabillityEmpty: 'אנא סמן לפחות ערך אחד',
    dropDown10: [
        'ינואר',
        'פברואר',
        'מרץ',
        'אפריל',
        'מאי',
        'יוני',
        'יולי',
        'אוגוסט',
        'ספטמבר',
        'אוקטובר',
        'נובמבר',
        'דצמבר',
    ],
    //2nd page
    parent1: 'הורה 1',
    parent2: 'הורה 2 (לא חובה):',
    secPageHeading1: 'פרטי הורים',
    secPageHeading3: 'אישור הורים',
    secPageHeading2: 'הצהרת הורים',
    secPageHeading4: 'אישור חשיפה',
    secPageHeading5: 'אישור ליווי נסיעה',
    parentPlaceholders: [
        'שם מלא',
        'ארץ לידה',
        'שנת עליה',
        'מספר טלפון',
        'מקום עבודה',
        'דוא”ל',
    ],
    seizureDropDownPlaceholder: 'תדירות התקפים',
    seizureOccurrenceOptions: [
        'פעם בשנה ויותר',
        'פעם בחצי שנה',
        'פעם בשלושה חודשים',
        'פעם בחודש',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        'שבועי',
        'יומי-מספר התקפים ביום',
    ],
    form3Text: [
        'אני מצהיר כי לבני/בתי אין כל מגבלה בריאותית',
        'יש לבני/בתי מגבלות בריאותיות/רגישויות המונעות השתתפות חלקית בפעילות הנדרשת (כגון: אסטמה, סוכרת נעורים, וכדומה)',
        'פירוט המגבלות הבריאותיות',
        'לבני/בתי יש אלרגיה',
        'לבני/בתי יש אלרגיה מסוג:',
        'אלרגיה מסכנת חיים',
        'לבני/בתי יש קושי בתחומים הבאים (תקשורתית, קוגניטיבית, פיזית, חושית, רגשית, אחר)',
        'סוג הקושי',
        'בני/בתי נעזר/ת בציוד רפואי כגון משאף או ערכת זריקות',
        'פירוט הציוד הרפואי',
        'השימוש נעשה באופן עצמאי',
        'בני/בתי מקבל/ת טיפול תרופתי. ',
        'בני/בתי סובל מאפילפסיה.',
        'פירוט סוגי תרופה ואופן הטיפול בה',
        'מתי קיבל את ההתקף הראשון?',
        'מתי קיבל התקף לאחרונה?',
        'איזה תרופות צורך?',
        'מתי ביקר לאחרונה אצל ניורולוג?',
        'סדר פעולות מומלץ בהתקף',
        'גורמים מעוררי התקף',
        // 'תדירות התקפים',
        'איך נראה התקף?',
        'סימנים מקדימים להתקף',
        `הנני מאשר בזאת כי אין מניעה שבני/בתי ישתתף/תשתתף בפעילות בתנועה למרות הופעת התקפי האפילפסיה.ידוע לי כי במידה ויהיה שינוי בתדירות ובעוצמת ההתקפים של בני / ביתי , או ביכולת הצוות בסניף להתמודד, ייתכן ויהיה צורך בנוכחותי או מבוגר מטעם המשפחה בזמן הפעילות.בחתימתי אני גם מאשר את  הנחייתי שלעיל להתנהלות בעת התקף אפילפסיה של בני / בתי.`,
    ],
    firstSeizureOccurrenceEmpty: 'אנא מלא שדה זה',
    lastSeizureOccurrenceEmpty: 'אנא מלא שדה זה',
    epilepsyDrugsUseEmpty: 'אנא מלא שדה זה',
    lastNeurologistVisitEmpty: 'אנא מלא שדה זה',
    actionSequenceRecommendedEmpty: 'אנא מלא שדה זה',
    seizureCatalistsEmpty: 'אנא מלא שדה זה',
    seizureFrequencyEmpty: 'אנא בחר תדירות',
    howDoesSeizureLookLikeEmpty: 'אנא מלא שדה זה',
    preSeizureSignsEmpty: 'אנא מלא שדה זה',
    seizureTermsApprovalEmpty: 'אנא אשר שדה זה',
    epilepsyNotification: `'כנפיים של קרמבו' תפעל על פי הנחיות ההורה באופן מידי בעת ההתקף, אולם אם ההתקף נמשך מעל 5 דקות, או חוזר על עצמו - יוזעק אמבולנס לסניף, זאת בהתאם להוראות חוזר מנכ"ל משרד החינוך,  תשס"ב/2(א), י"ד תשרי תשס"ב, 1 באוקטובר 2001.לאור האמור לעיל, אנו מבקשים אישורכם לפעילות בנכם / בתכם כדלקמן :`,
    simuLev: '*שימו לב',
    form4Text: [
        `הנני מאשר/ת לבני/בתי להשתתף בפעילות "כנפיים של קרמבו”.`,
        `  ידוע לי כי אין באפשרות התנועה לספק את התנאים הדרושים על מנת למנוע חשיפה לאלרגנים/ גורמים מעוררי אפילפסיה ולכל גורם נוסף העלול להוביל ליצירת התקף כלשהו.`,
        `מחובתי לצייד את בני/בתי בכל הנדרש למתן טיפול רפואי בגין מצב רפואי ידוע.`,
    ],
    form5Text: [
        [
            { text: 'לא מאשר כלל', checked: false },
            { text: 'מאשר בתיאום מראש בלבד', checked: false },
            { text: 'מאשר', checked: false },
            { text: 'מאשר למטרות הבאות בלבד: ', checked: false },
        ],
        [
            {
                text: 'שימוש פנימי (במסגרת תצוגה בסניף בלבד - לוח תמונות, מצגות וסרטונים).',
                checked: false,
            },
            { text: 'מצגות- הכשרות, סמינרים, גיוסים.', checked: false },
            {
                text: "רשתות חברתיות (פייסבוק/אינסטגרם/סנפצ'אט).",
                checked: false,
            },
            {
                text: 'לכל מטרה במסגרת חשיפת הפעילות של התנועה בציבור',
                checked: false,
            },
            {
                text: 'תוכן שיווקי - קמפיינים פרסומיים של התנועה (ארצי/עירוני).',
                checked: false,
            },
            {
                text: 'תקשורת - ארצית/מקומית - עיתונות כתובה/טלוויזיה.',
                checked: false,
            },
        ],
        'ידוע לי כי פרטי בני/בתי מועברים לעיתים לרשות מקומית/משרדי ממשלה/חברות ביטוח לצרכי תמיכה וביטוח.',
    ],
    form6Text: [
        "כחלק מנגישותה של התנועה, 'כנפיים של קרמבו' מעמידה מערך היסעים לפעילות השבועית וממנה, שמאפשר לפעילים שאינם עצמאיים וזקוקים לתיווך אישי,להשתתף בפעילות באופן קבוע. את מערך ההיסעים מלווים בני נוער עצמאיים בגילאי 16-18 הפעילים בסניף. מערכי ההיסעים והכשרת מלווי ההסעות מוחזקים ומועברים בסניפים בהנחיית מחלקת בטיחות ומפעלים של התנועה.",
        'ידוע לי כי בני/בתי עשויים לקחת חלק במערך ההיסעים כמלווים של פעילי התנועה הזקוקים להסעה, ליווי הכרוך בנסיעה ברכב ההסעות.',
        'הנני מאשר/ת לבני/בתי להצטרף למערך ההיסעים, אשר הליווי בו מתבצע על ידי בני ובנות נוער הפעילים בסניף.',
        'אני מאשר/ת שקראתי את תקנון התנועה ומקבל/ת כל התנאים הכתובים בו.',
        'שם ההורה המאשר',
        'מס’ ת”ז',
        'דרכי החזרה של בני/בתי מהסניף ביום הפעולה:',
    ],
    //page 2 validations
    // parent1fullNameEmpty: '1',
    // parent1placeOfBirthEmpty: '1',
    // parent1phoneEmpty: '1',
    // parent1workPlaceEmpty: '1',
    // parent1emailEmpty:'1',
    parent2phoneInvalid: 'טלפון לא תקין',
    parent2emailInvalid: 'כתובת דוא"ל אינה תקינה',
    inCaseOfLethalAllergyP:
        'במצב זה, הנך נדרש להמציא הצהרת רופא בנוגע לאלרגיה/רגישות לנוחיותך, מצ״ב פורמט',
    inCaseOfLethalAllergyA: 'לחץ כאן להורדה',
    typeOfAlergyEmpty: 'אנא פרט את סוג האלרגיה',
    typeOfDifficultyEmpty: 'אנא פרט את סוג הקושי',
    medicalEquipmentDescriptionEmpty: 'אנא פרט את הציוד הרפואי',
    parentApprovalEmpty: 'אנא אשר הצהרה',
    parentApproval2Empty: 'אנא אשר הצהרה',
    parentApproval3Empty: 'אנא אשר הצהרה',
    exposureAprrovalEmpty: 'אנא אשר שדה',
    kindOfExposureEmpty: 'אנא בחר מטרה',
    parentApprovalPublicAuthEmpty: 'אנא אשר שדה',
    lastFormParentAproval1Empty: 'אנא אשר הצהרה',
    lastFormParentAproval2Empty: 'אנא אשר הצהרה',
    lastFormParentAproval3Empty: 'אנא אשר הצהרה',
    approvedParentEmpty: 'אנא הזן את שם ההורה המאשר',
    approvedParentIdEmpty: 'אנא הזן תעודת זהות',
    approvedParentIdInvalid: 'תעודת זהות אינה תקינה',
    //
    secondFormSubmitBtn: 'המשך לתשלום',
    finishNoPayForm: 'הרשם',
    //third page
    openYear: 'פתיחת שנה',
    addings: 'תוספות',
    summery: 'סיכום תשלום',
    register: 'הרשמה',
    shirt: 'חולצה',
    add: 'הוסף',
    added: 'נוסף',
    remove: 'הסר',
    registerCost: 'עלות ההרשמה',
    shirtCost: 'עלות הזמנת חולצה',
    totalPay: 'סה”כ:',
    payNow: 'שלם עכשיו',
    requestSent:
        'בקשתך נקלטה במערכת. לאחר אישור פנייתך, ישלח אליך מייל לסיום תהליך ההרשמה.',
    CITIES: cities_1.default.map((m) => m.name),
};
exports.workshops = {
    header: 'הרצאות וסדנאות',
    subheader: `"כנפיים של קרמבו"  הינה תנועת נוער רב גונית, בה פעילים ביחד ילדים ונוער עם ובלי מוגבלויות, מכל רבדי החברה הישראלית: חילונים, דתיים, מוסלמים, נוצרים, בדואים, דרוזים, מכל קשת הלקויות ודרגות החומרה.  `,
    mainTextOne: `ב"כנפיים של קרמבו" פותח מודל שילוב והכלה חדשני, המחבר בין ילדים ובני נוער עם צרכים מיוחדים לבין בני נוער מהחינוך הכללי, מכל קצוות החברה. `,
    mainTextTwo: `המודל מאפשר פעילות משותפת, נגישה ומותאמת המביאה לידי ביטוי את היכולות של כל הפעילים. בשל השינוי שפעילות זו מחוללת בחברה הישראלית כלפי אוכלוסיית הצרכים המיוחדים וכלפי אוכלוסיות מודרות בכלל, זכה מודל השילוב הייחודי של התנועה להכרה בין לאומית ע"י האו"ם ו"כנפיים של קרמבו" זכו המעמד של "יועץ מיוחד" בנושא שילוב (יולי 2018). `,
    mainTextThree: `אנו מציעים מגוון של פעילויות, הרצאות וסדנאות, מוכנות מראש או בבנייה והתאמה אישית במגוון נושאים (עולם הצרכים המיוחדים, פעילות משלבת, רוח קרמבו וערכי קרמבו ועוד).`,
    mainTextFour: `באם אתם מעוניינים בהרצאה / סדנה `,
    mainTextFive: `מלאו טופס קצר שנוכל להתאים את ההרצאה או הסדנה לצרכים המדויקים שלכם.`,
    mainTextSix: `אנא הקדישו זמן ומחשבה למילוי הטופס, מלאו את הפרטים בהרחבה והוסיפו בהערות מידע נוסף אם צריך על מנת שנוכל לענות על הצרכים בצורה המיטבית ביותר!`,
    mainTextSeven: `*חוברת ההרצאות והסדנאות מצורפת וניתן לעיין בה.`,
    mainH1: 'טופס לבניית הרצאה/סדנה - כנפיים של קרמבו',
    mainB: 'שלום רב',
    mainP1: '"כנפיים של קרמבו"  הינה תנועת נוער רב גונית, בה פעילים ביחד ילדים ונוער עם ובלי מוגבלויות, מכל רבדי החברה הישראלית: חילונים, דתיים, מוסלמים, נוצרים, בדואים, דרוזים, מכל קשת הלקויות ודרגות החומרה.  ',
    mainP2: `ב"כנפיים של קרמבו" פותח מודל שילוב והכלה חדשני, המחבר בין ילדים ובני נוער עם צרכים מיוחדים לבין בני נוער מהחינוך הכללי, מכל קצוות החברה. המודל מאפשר פעילות משותפת, נגישה ומותאמת המביאה לידי ביטוי את היכולות של כל הפעילים. בשל השינוי שפעילות זו מחוללת בחברה הישראלית כלפי אוכלוסיית הצרכים המיוחדים וכלפי אוכלוסיות מודרות בכלל, זכה מודל השילוב הייחודי של התנועה להכרה בין לאומית ע"י האו"ם ו"כנפיים של קרמבו" זכו המעמד של "יועץ מיוחד" בנושא שילוב (יולי 2018).`,
    mainP3: 'אנו מציעים מגוון של פעילויות, הרצאות וסדנאות, מוכנות מראש או בבנייה והתאמה אישית במגוון נושאים (עולם הצרכים המיוחדים, פעילות משלבת, רוח קרמבו וערכי קרמבו ועוד). נשמח שתמלאו טופס קצר שנוכל להתאים את ההרצאה או הסדנה לצרכים המדויקים שלכם. אנא הקדישו זמן ומחשבה למילוי הטופס, מלאו את הפרטים בהרחבה והוסיפו בהערות מידע נוסף אם צריך על מנת שנוכל לענות על הצרכים בצורה המיטבית ביותר!',
    formH1: 'פרטים ליצירת קשר ומידע על הארגון',
    formH1Span: '(נא למלא את כל הפרטים)',
    formName: 'שם מלא',
    formPhone: 'נייד ליצירת קשר',
    formMail: 'אימייל ליצירת קשר',
    formOrgName: 'שם האירגון הפונה',
    formTextArea: 'נשמח אם תוסיפו כמה מילים על האירגון ופעילותו בכלליות',
    formTextAreaMobile: 'פירוט האירגון ופעילותו הכללית',
    formDate: 'תאריך מבוקש להנחיה*',
    formPlace: 'מקום ההרצאה/ הסדנה/ הביקור:',
    formDisclaimer:
        '*במידה והתאריך אינו ידוע או שמדובר בסדנה של יותר ממפגש אחד השאירו שדה זה ריק',
    sendForm: 'שלח טופס',
    errGeneral: 'שדה חובה',
    errPhone: 'טלפון לא תקין',
    errEmail: 'כתובת מייל לא תקינה',
    headingDetails: 'פרטים על ההרצאה/סדנה/ביקור',
    fillAll: '(נא למלא את כל הפרטים)',
    formFirstRadioHeader: 'מתענינים ב',
    formFirstRadioOption1: 'הרצאה',
    formFirstRadioOption2: 'סדנה (יותר ממפגש אחד)',
    formFirstRadioOption3: 'ביקור מונחה בסניף',
    formFirstRadioElse: 'משהו אחר',
    formGoalsHeader: 'מהי מטרת הפעילות?',
    formGoalsSubHeader:
        'אתגרים שרוצים לפתור, שינוי תפיסה, הרחבת אופקים, שילוב מיטבי, היכרות עם עולם הצרכים המיוחדים ועוד…',
    formDurationHeader: 'פרק זמן המוקצה למפגש',
    intrestedInSubjectsHeader: 'נושאים שיכולים לעניין אותכם',
    intrestedInSubjectsOption1: 'עקרונות ההדרכה המשלבת',
    intrestedInSubjectsOption2: 'תהליכי העצמה',
    intrestedInSubjectsOption3: 'רוח קרמבו וערכי קרמבו',
    intrestedInSubjectsOption4: 'ברוכים הבאים לעולם הצרכים המיוחדים',
    intrestedInSubjectsOption5: 'עיבוד חושי - הקשר לתפקודים יום יומיים',
    howDidYouArrive: 'איך הגעתם אלינו',
    howDidYouArriveOption1: 'דרך האתר',
    howDidYouArriveOption2: 'דרך חברים',
    howDidYouArriveOption3: 'היינו בהרצאה או פעילות משותפת בעבר',
    audienceDetails: 'פרטים על קהל היעד',
    attributesHeader: 'תארו את מאפייני משתתפי הקבוצה',
    attributesDetails: 'מהיכן, גילאים, מוגבליות, תחומי עיסוק, ועוד…',
    practicipatesAmount: 'כמות משתתפים',
    practicipatesRelationsHeader: 'מה היא מידת ההיכרות של הקבוצה',
    practicipatesRelationsDetails:
        'האם הקבוצה נפגשת לראשונה בפעילות, האם הם מכירים ממקום העבודה, נפגשים לעיתים תכופות או עוברים פעילות יחד באופן קבוע',
    practicipatesAdjustmentsHeader: 'האם יש בקהל משתתפים הדורשים התאמות',
    practicipatesAdjustmentsDetails:
        'לקויי ראיה אנשים בעלי נכויות שונות - אם כן - נא לפרט',
    notes: 'הערות נוספות',
};
const managers = [
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/talya.jpg',
        ManageName: 'Talia Harel Bejerano',
        Manageposition: 'Chief Executive Officer',
        ManageEmail: 'talia@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText:
            'שירתה כקצינת חינוך בצה"ל (השתחררה בדרגת סגן). בוגרת ומנחת קבוצות במיכא"ל. בוגרת האוניברסיטה העברית, תואר BA ביחסים בינלאומיים ומדעי המדינה (בהצטיינות) בוגרת תואר שני במנהל עסקים, אוניברסיטת תל אביב. מנכ"ל כנפיים של קרמבו מיוני 2016. ',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/גיל.jpg',
        ManageName: 'Gil Doron',
        Manageposition: 'VP, Operations and Strategic Partnerships',
        ManageEmail: 'gil@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText:
            'שירת במודיעין חיל הים. בעל ניסיון רב בפיתוח וניהול מיזמים במגזר השלישי, עבד בקבוצת שכולו טוב, בית אקשטיין, האגודה לסוכרת נעורים.בוגר ממכללת רופין, תואר ראשון (B.A) במדעי ההתנהגות. בוגר תואר שני במנהל עסקים של אוניברסיטת חיפה במסלול של ניהול אלכ"רים. ראש מטה ממאי 2018.  ',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/ido.jpeg',
        ManageName: 'Ido Eisikovits Reichman',
        Manageposition: 'VP, Resource Development and Marketing',
        ManageEmail: 'idor@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText: '',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/סתיו.jpeg',
        ManageName: 'Stav Weitz',
        Manageposition: 'VP of Programs',
        ManageEmail: 'stav@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText:
            'בוגרת תואר ראשון בלימודי חינוך ומדינת ישראל באוניברסיטת בן גוריון, בעבר מנהלת מרחב דרום בעמותת איילים ומנהלת כפר הסטודנטים באשלים. מנהלת פעילות שטח החל מינואר 2015',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/Yaniv_Krembo.jpg',
        ManageName: 'Yaniv Nuni',
        Manageposition: 'VP, Finance and Administration',
        ManageEmail: 'nuni@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText:
            'שירת בחיל הקשר. ניסיון רב בניהול כספים בארגונים מסחריים וקמעוניים. רואה חשבון החל משנת 2013.  בעל תואר B.A במינהל עסקים, התמחות בחשבונאות המכללה האקדמית קרית אונו. בוגר קורס כלכלן פרקטי . מנהל כספים החל מינואר 2019.',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/טל.jpg',
        ManageName: 'Tal Ben Arie Menashes',
        Manageposition: 'VP, Human Resources',
        ManageEmail: 'hr@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText:
            'בעלת למעלה מ 13 שנות ניסיון במשאבי אנוש במגזר העסקי. כיהנה כסמנכ"ל משאבי אנוש בחברות : Viber, ePlane  ו - iMesh,, בעלת תואר שני בתרבות ומגדר מאוניברסיטת אמסטרדם ותואר ראשון בתקשורת ומדעי המדינה, מאוניברסיטת תל-אביב. מנהלת משאבי אנוש החל ',
    },
    // {
    //     ManageImg: 'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/nurit.jpg',
    //     ManageName: 'Nurit Ben Asher-Golan',
    //     Manageposition: 'VP, Diversity and Inclusion',
    //     ManageEmail: 'nurit@krembo.org.il',
    //     ManagePhone: '',
    //     ManageHiddenText: 'שירתה כקצינת חינוך בצה"ל (השתחררה בדרגת סגן). בוגרת המכללה האקדמית תל חי. תואר BA בחינוך מיוחד ופסיכולוגיה. בוגרת תעודת הוראה בחינוך מיוחד, אוניברסיטת תל אביב. מנהלת מחלקה מקצועית- מרץ 2015 '
    // },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/User photo icon.svg',
        ManageName: 'Sharon Arber',
        Manageposition: 'Legal Counsel',
        ManageEmail: 'krembo_law@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText: '',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/User photo icon.svg',
        ManageName: 'Chen Dushi Swary (Furlough)',
        Manageposition: 'Head of Alumni Programs',
        ManageEmail: 'chend@krembo.org.il',
        ManagePhone: '052-2547538',
        ManageHiddenText:
            'שמשה במהלך עשר שנים כבעלים משותף ומנהלת יחסי הציבור וקשרי הלקוחות של קבוצת מיתוס (חברת שיווק והפקות אירועים שיווקיים מהמובילות בישראל).בעברה שימשה בתפקידי יחסי ציבור ודוברות בארגונים ומשרדים מובילים כארד תקשורת, שיאון תקשורת ופרסום שירה שקולניק.בעלת תואר ראשון ולימודי תקשורת מאוניברסיטת תל אביב, מנהלת את תחום יחסי הציבור בכנפיים של קרמבו החל מינואר 2014.',
    },
    //   {
    //     ManageImg:
    //       'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/User photo icon.svg',
    //     ManageName: 'Ianir Lewin',
    //     Manageposition:
    //       'Director of Safety & Security, Coronavirus Supervisor and Accessibility Coordinator',
    //     ManageEmail: 'Ianir@krembo.org.il',
    //     ManagePhone: '052-2547538',
    //   },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/User photo icon.svg',
        ManageName: 'Roei Saban',
        Manageposition:
            'Logistics & Purchasing Manager and Accessibility Coordinator',
        ManageEmail: 'roei@krembo.org.il',
    },
];
const managers_branches = [
    {
        name: 'דוד קאופמן',
        position: 'מנהל תפעול ובטיחות',
        phone: '052-7977850 ',
        email: 'david@krembo.org.il',
    },
    {
        name: '	הדס שטנגר',
        position: 'מנהלת מחלקת הדרכה',
        phone: '054-2175735 ',
        email: 'Hadass@krembo.org.il',
    },
    {
        name: '	סתיו ויץ	',
        position: 'מנהלת מחלקת פיתוח ופעילות ארצית',
        phone: ' 054-2542692 ',
        email: 'stav@krembo.org.il',
    },
    {
        name: 'עדי אליהו',
        position: 'מנהלת תחום שנת שירות והגשמה',
        phone: '	050-6392984 ',
        email: 'adieliyahu@krembo.org.il',
    },
    {
        name: '	עדי אלאלוף',
        position: 'מנהלת פעילות ארצית',
        phone: '052-3418444 ',
        email: 'adia@krembo.org.il',
    },
    {
        name: ' 	אייל גולדמן',
        position: ' 	מנהל מחוז צפון',
        phone: '054-5921252  ',
        email: 'eyalg@krembo.org.il',
    },
    {
        name: 'נוי כוכבה',
        position: 'רכזת שילוב מחוז צפון',
        phone: '052-3226333 ',
        email: 'noykochva@krembo.org.il',
    },
    {
        name: 'עתליה שפר	',
        position: '	מנהלת מחוז שרון',
        phone: '052-8991404',
        email: 'atalya@krembo.org.il',
    },
    {
        name: 'עדי אלוני	',
        position: '	רכזת שילוב מחוז שרון',
        phone: '052-6454225',
        email: 'adi.aloni@krembo.org.il',
    },
    {
        name: 'עידו ברנע',
        position: 'מנהל מחוז מרכז	',
        phone: '054-5400617    ',
        email: 'ido@krembo.org.il   ',
    },
    {
        name: 'אור וינרייך',
        position: 'רכזת שילוב מחוז מרכז',
        phone: '050-2440460',
        email: 'or@krembo.org.il',
    },
    {
        name: 'חוליאן קרסנבלט',
        position: 'רכז עירוני תל אביב- יפו',
        phone: '050-7420989',
        email: 'julian.krembo@gmail.com',
    },
    {
        name: 'שקד בן משה',
        position: 'רכזת שילוב מחוז שפלה',
        phone: '052-5672952 ',
        email: 'shaked@krembo.org.il',
    },
    {
        name: 'לינה נבואני	',
        position: '	מנהל מחוז החברה הערבית',
        phone: '054-6738874 ',
        email: 'lina@krembo.org.il',
    },
    {
        name: '	מג´דולין אבו חוף',
        position: 'רכזת שילוב מחוז החברה הערבית',
        phone: '050-3068330',
        email: 'majdoleen@krembo.org.il',
    },
    {
        name: 'שרה פארן',
        position: 'רכזת שילוב מחוז דרום',
        phone: '058-6518562 ',
        email: 'saraf@krembo.org.il',
    },
    {
        name: 'רועי סבן ',
        position: 'מנהל רכש',
        phone: '0542378020 ',
        email: 'roei@krembo.org.il',
    },
];
const managers_vaad = [
    {
        ManageImg:
            'https://dfy7olpsj9k0c.cloudfront.net/krembo/Nir Bronstein.jpg',
        ManageName: 'Nir Bronstein',
        Manageposition: 'Chairman of the Board',
        ManageHiddenText:
            'Nir has been involved in various philanthropic activities for the community for the last decade, focusing on activities for children with disabilities. In the past seven years, Nir has served as CEO of Poalim Capital Markets and as chairman of its subsidiary, Poalim Securities in the US. Before that, he served as president and CEO of Tamir Fishman Investments. Currently, Nir serves as a director in several Israeli companies. Nir is a graduate of the management training program of the London Business School. ',
    },
    {
        ManageImg: 'https://dfy7olpsj9k0c.cloudfront.net/krembo/Hain Shane.JPG',
        ManageName: 'Chen Shain',
        Manageposition: 'Board Member and Chairman of the Finance Committee',
        ManageHiddenText:
            'Chen Shain has been an accountant and executive partner in the firm Earnest & Young Israel since 1991. He is a member of the firm’s managing committee, and is responsible for its real-estate and non-profit departments. Chen has extensive experience in managing non-profit organizations, including Tel Aviv University, the Weizmann Institute of Science, Perach, the Philharmonic Orchestra, and more. He holds a bachelor’s degree in economics and accounting, and a master’s degree in funding from Tel Aviv University.',
    },
    {
        ManageImg:
            'https://dfy7olpsj9k0c.cloudfront.net/krembo/Klaodia Kobi.jpg',
        ManageName: 'Claudia Koby',
        Manageposition: 'Board Member and Co-founder',
        ManageHiddenText:
            'Claudia is the mother of Kfir Koby, Krembo Wing’s first member and the movement’s inspiration. She is the owner of True Design – a design and branding company founded in 1996. In addition, Claudia chairs the steering committee, and as a board member, she is responsible for special needs in Krembo Wings. Claudia developed the movement’s counseling system. She is a graduate of the Visual Communications Department, Bezalel Academy of Art and Design, with a bachelor’s degree in design.',
    },
    {
        ManageImg:
            'https://dfy7olpsj9k0c.cloudfront.net/krembo/User photo icon.svg',
        ManageName: 'Avi Nissan',
        Manageposition: 'Board Member',
        ManageHiddenText:
            'Avi is an accountant and holds a bachelor’s degree in business management. Avi owns the accounting firm Avi Nissan – Accounting. He is married, has three children, and lives in Tel Aviv.',
    },
    {
        ManageImg: 'https://dfy7olpsj9k0c.cloudfront.net/krembo/tal.600.jpg',
        ManageName: 'Tal Eisner',
        Manageposition: 'Board Member',
        ManageHiddenText:
            'For several years now, Tal has been involved in several programs for children with special needs. He joined Krembo Wings’ board of directors in 2008. He has served in several positions in high-tech companies that specialize in cyber-fraud prevention. Currently, Tal works for Checkpoint, and is a member of the general assembly of Beit Issie Shapiro. He is a graduate of Tel Aviv University, married with six children.',
    },
    {
        ManageImg:
            'https://dfy7olpsj9k0c.cloudfront.net/krembo/Ika Abarbanel.jpg',
        ManageName: 'Ika Abravanel',
        Manageposition: 'Board Member',
        ManageHiddenText:
            'Ika specializes in integration management. He is a former manager at Teva Pharmaceutical Industries, head integration manager, and executive VP of HR and joint chairman of Teva and Procter & Gamble. Ika served as senior VP at Bezeq Telecommunications and as executive VP of operations and customer service at Pelephone. He served in the IDF for 25 years. Ika is a graduate of the National Security College with both a bachelor and master’s degree in political science. He held various positions in third-sector organizations – as founder and chairman of Ametz Lochem, president of Prize4Life, and board member of Bezalel.',
    },
    {
        ManageImg:
            'https://dfy7olpsj9k0c.cloudfront.net/krembo/Nurit berman.jpg',
        ManageName: 'Nurit Berman',
        Manageposition: 'Board Member',
        ManageHiddenText:
            'Nurit is the director of Emda Group, which deals with HR strategies. She is a certified social worker.',
    },
    {
        ManageImg:
            'https://dfy7olpsj9k0c.cloudfront.net/krembo/Tamir Dagan.jpg',
        ManageName: 'Tamir Dagan',
        Manageposition: 'Board Member',
        ManageHiddenText:
            'Tamir is a graduate of the Hebrew University, with a bachelor’s degree in economics and statistics, and a graduate of Ben Gurion University, with a master’s degree in business management.',
    },
];
exports.default = {
    LANGUAGE: exports.LANGUAGE,
    navbar: exports.navbar,
    mainpage: exports.mainpage,
    press: exports.press,
    reports: exports.reports,
    thanks: exports.thanks,
    event: exports.event,
    donate: exports.donate,
    branches: exports.branches,
    about: exports.about,
    signup: exports.signup,
    footer: exports.footer,
    contact: exports.contact,
    educational: exports.educational,
    activity: exports.activity,
    vision: exports.vision,
    symbol: exports.symbol,
    register: exports.register,
    workshops: exports.workshops,
    managers,
    managers_branches,
    managers_vaad,
    PERSONAL: exports.PERSONAL,
    PERMISSIONS: exports.PERMISSIONS,
    PARENTS: exports.PARENTS,
    all_branches: branch_parser_1.branchprices,
};
//# sourceMappingURL=content_english.js.map
